import { openAdmissionPrint } from '../config/openAdmissionPrint';
import axios from "axios";
import { admission, mua, site } from "../config/api";

import {
  Badge,
  Button,
  Dialog,
  DocumentIcon,
  EditIcon,
  EyeOpenIcon,
  FilePicker,
  FloppyDiskIcon,
  Link,
  MapIcon,
  Pane,
  Spinner,
  Text,
  TimeIcon,
} from "evergreen-ui";
import {
  AiOutlineFileExclamation,
  AiOutlineFileDone,
  AiFillFile,
  AiOutlineFieldTime,
} from "react-icons/ai";
import { MDBDataTableV5 } from "mdbreact";
import React, { useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { FaClock, FaNewspaper, FaUserSlash, FaUserNurse } from "react-icons/fa";
import { FaMoneyBills, FaReceipt } from "react-icons/fa6";
import {
  AiFillCloseCircle,
  AiFillCheckCircle,
  AiOutlineFileSearch,
  AiFillClockCircle,
} from "react-icons/ai";
import { MdOutlinePayments } from "react-icons/md";
import { BiCheck, BiSolidUserBadge } from "react-icons/bi";
import Swal from "sweetalert2";
import { MetaTags } from "react-meta-tags";
import { BsPaypal, BsQrCode } from "react-icons/bs";
import nuFile from "../assets/filenu/nurform.pdf";

function NewDataRegister() {
  const [DataRegister, setDataRegister] = useState([]);
  const [FirstFetch, setFirstFetch] = useState(false);
  const [IshowEditFile, setIshowEditFile] = useState(false);
  const [ModalPayKRU, setModalPayKRU] = useState(false);

  const [isShowPay, setisShowPay] = useState(false);

  const startDate = new Date("2024-09-30 16:30");
  const endDate = new Date("2024-10-04 23:50");

  // ดึงวันปัจจุบัน
  const currentDate = new Date();

  // เช็คว่า currentDate อยู่ระหว่าง startDate และ endDate หรือไม่
  const isInRange = startDate <= currentDate && currentDate <= endDate;
  const dataTitle = [
    {
      major_id: "8301",
      status: "4",
      text1: "*หมายเหตุ",
      text2:
        "1. ผู้ผ่านการคัดเลือก (ตัวจริง) สามารถยืนยันสิทธิ์และชำระค่าธรรมเนียมการศึกษาได้ ตั้งแต่วันนี้ - 28 กุมภาพันธ์ 2568",
      text3: "",
      text4: "",
      text5: "",
    },
    {
      major_id: "8201",
      status: "4",
      text1: "*หมายเหตุ",
      text2:
        "1. ผู้ผ่านการคัดเลือก (ตัวจริง) สามารถยืนยันสิทธิ์และชำระค่าธรรมเนียมการศึกษาได้ ตั้งแต่วันนี้ - 28 กุมภาพันธ์ 2568",
      text3: "",
      text4: "",
      text5: "",
    },
    {
      major_id: "8201",
      status: "41",
      text1: "",
      text2: "",
      text3: "",
      text4: "",
      text5: "",
    },
  ];
  const CheckPayPresent = (close, open) => {
    const MONEY_CLOSE = new Date(close + " 23:59");
    const MONEY_OPEN = new Date(open + " 00:00");
    const MONEY_NOW = new Date();
    console.log(MONEY_CLOSE);
    console.log(MONEY_OPEN);
    console.log(MONEY_NOW);
    if (MONEY_OPEN <= MONEY_NOW && MONEY_NOW <= MONEY_CLOSE) {
      return true;
    } else {
      return false;
    }
  };
  const CheckPayPresentOpen = (close, open) => {
    const MONEY_CLOSE = new Date(close + " 00:00");
    const MONEY_NOW = new Date();
    if (MONEY_CLOSE >= MONEY_NOW) {
      return true;
    } else {
      return false;
    }
  };

  const CheckDAte = (close, rob_id) => {
    const closedate =
      close.split("/")[2] + "-" + close.split("/")[1] + "-" + close.split("/")[0] + " 23:00";
    const starts = "2025-03-25 00:00";
    const now = new Date();
    const check = new Date(closedate);
    const start = new Date(starts);
    console.log(start);
    if (start <= now && check >= now) {
      return false;
    } else {
      return true;
    }
  };
  const CheckDatePresent = (params) => {
    const starts = "2025-04-09 00:00";
    const start = new Date(starts);
    const stops = "2025-05-10 23:59";
    const stop = new Date(stops);
    // console.log(start)
    // console.log(stop)
    const date = new Date();
    // console.log(date)
    if (date >= start && date <= stop) {
      /// false เท่ากับเปิด
      return false;
    } else {
      // console.log("ปิด")
      /// true เท่ากับปิด
      return true;
    }
  };
  const CheckDatePayKru = (params) => {
    const starts = "2025-04-24 00:00";
    const start = new Date(starts);
    const stops = "2025-04-28 23:59";
    const stop = new Date(stops);
    // console.log(start)
    // console.log(stop)
    const date = new Date();
    // console.log(date)
    if (date >= start && date <= stop) {
      /// false เท่ากับเปิด
      return false;
    } else {
      // console.log("ปิด")
      /// true เท่ากับปิด
      return true;
    }
  };

  const GetNews = async (type, major, rob) => {
    try {
      if (major === "9903") {
        type = "0";
      }
      const fetch = await axios.post(admission + "/student/getNews", {
        type: type,
        major: major,
        rob_id: rob,
      });
      const resp = fetch.data;
      console.log(resp);
      return admission + "/" + resp;
    } catch (error) {}
  };
  const [Pay, setPay] = useState({
    term: "",
  });
  const OpenPayRegister = (term, fullname, idno, robclose, robmoney) => {
    var splitName = fullname.split(" ");
    setPay({
      term: "1/" + term,
      name: splitName[0],
      lname: splitName[1],
      ID_NO: idno,
      stopdate: robclose,
      amount: robmoney,
    });
    setisShowPay(true);
  };

  const checkdate = (val) => {
    const date = val.split("/")[2] - 543 + "-" + val.split("/")[1] + "-" + val.split("/")[0];
    const datenow = new Date().toDateString();
    const endDate = new Date(date).toDateString();
    const chk = datenow <= endDate;
    console.log(chk);
    console.log(datenow);
    console.log(endDate);
    return !chk;
    // return chk;
  };

  const StartComponent = async (params) => {
    try {
      // ขอ JWT ถ้าเข้ามาด้วยเลขบัตรอย่างเดียว (หน้าตรวจสอบสถานะ)
      if (!localStorage.getItem("token") && localStorage.getItem("citizent")) {
        try {
          const tokenRes = await axios.get(
            mua +
              "/admissionnew2022/showcheckmember/" +
              localStorage.getItem("citizent")
          );
          const auth = tokenRes?.data?.data?.auth;
          if (auth) localStorage.setItem("token", auth);
        } catch (e) {}
      }
      const fetch = await axios.get(
        mua + "/admissionnew2022/showlistregister?id=" + localStorage.getItem("citizent")
      );
      const data = fetch.data.data.data;
      console.log(data);
      if (data.length !== 0) {
        const dataTrue = data.filter(
          ({ ROB_ID, Major1_MAJOR_ID, REGISTER_STATUS }) =>
            !(ROB_ID === "91" && Major1_MAJOR_ID === "1104" && REGISTER_STATUS === "11")
        );
        if (Array.isArray(dataTrue)) {
          const dataMajor = [];
          const dataMajorNu = [];

          dataTrue.forEach((i) => {
            console.log(i.REGISTER_ID);
            if (i.Major1_MAJOR_ID === "9902") {
              if (i.Major1_LEVEL_OPEN_ID !== null) {
                dataMajorNu.push({
                  Major_LEVEL_OPEN_ID: i.Major1_LEVEL_OPEN_ID,
                  Major_LEVEL_OPEN_NAME: i.Major1_LEVEL_OPEN_NAME,
                  Major_MAJOR_CLASSROOM: i.Major1_MAJOR_CLASSROOM,
                  Major_MAJOR_CLASSROOM2: i.Major1_MAJOR_CLASSROOM2,
                  Major_MAJOR_CLASSROOM3: i.Major1_MAJOR_CLASSROOM3,
                  Major_MAJOR_ID: i.Major1_MAJOR_ID,
                  Major_MAJOR_NAME: i.Major1_MAJOR_NAME,
                  Major_course_year: i.Major1_course_year,
                  Major_course_year_id: i.Major1_course_year_id,
                  Major_course_year_name: i.Major1_course_year_name,
                  Major_faculty_name: i.Major1_faculty_name,
                  REGISTER_TYPE_ID: i.REGISTER_TYPE_ID,
                  REGISTER_ID: i.REGISTER_ID,
                  ROB_ID: i.ROB_ID,
                  REGISTER_STATUS_BILL_ROBFULL_BOOK: i.REGISTER_STATUS_BILL_ROBFULL_BOOK,
                  REGISTER_STATUS_BILL_ROB1_BOOK: i.REGISTER_STATUS_BILL_ROB1_BOOK,
                  REGISTER_STATUS_BILL_ROB1_NO: i.REGISTER_STATUS_BILL_ROB1_NO,
                  REGISTER_STATUS_BILL_ROB1_COUNT: i.REGISTER_STATUS_BILL_ROB1_COUNT,
                  REGISTER_STATUS_BILL_ROB2_BOOK: i.REGISTER_STATUS_BILL_ROB2_BOOK,
                  REGISTER_STATUS_BILL_ROB2_NO: i.REGISTER_STATUS_BILL_ROB2_NO,
                  REGISTER_STATUS_BILL_ROB2_COUNT: i.REGISTER_STATUS_BILL_ROB2_COUNT,
                  ROB_YEAR: i.ROB_YEAR,
                  REGISTER_STATUS_BILL_ROBFULL_NO: i.REGISTER_STATUS_BILL_ROBFULL_NO,
                  REGISTER_STATUS_BILL_ROBFULL_COUNT: i.REGISTER_STATUS_BILL_ROBFULL_COUNT,
                  CITIZEN: i.CITIZENT_LOGIN,
                  REGISTER_STATUS: i.REGISTER_STATUS,
                });
                if (i.Major2_LEVEL_OPEN_ID !== null) {
                  dataMajorNu.push({
                    Major_LEVEL_OPEN_ID: i.Major2_LEVEL_OPEN_ID,
                    Major_LEVEL_OPEN_NAME: i.Major2_LEVEL_OPEN_NAME,
                    Major_MAJOR_CLASSROOM: i.Major2_MAJOR_CLASSROOM,
                    Major_MAJOR_CLASSROOM2: i.Major2_MAJOR_CLASSROOM2,
                    Major_MAJOR_CLASSROOM3: i.Major2_MAJOR_CLASSROOM3,
                    Major_MAJOR_ID: i.Major2_MAJOR_ID,
                    Major_MAJOR_NAME: i.Major2_MAJOR_NAME,
                    Major_course_year: i.Major2_course_year,
                    Major_course_year_id: i.Major2_course_year_id,
                    Major_course_year_name: i.Major2_course_year_name,
                    Major_faculty_name: i.Major2_faculty_name,
                    REGISTER_TYPE_ID: i.REGISTER_TYPE_ID,
                    REGISTER_ID: i.REGISTER_ID,
                    ROB_ID: i.ROB_ID,
                    REGISTER_STATUS_BILL_ROBFULL_BOOK: i.REGISTER_STATUS_BILL_ROBFULL_BOOK,
                    REGISTER_STATUS_BILL_ROB1_BOOK: i.REGISTER_STATUS_BILL_ROB1_BOOK,
                    REGISTER_STATUS_BILL_ROB1_NO: i.REGISTER_STATUS_BILL_ROB1_NO,
                    REGISTER_STATUS_BILL_ROB1_COUNT: i.REGISTER_STATUS_BILL_ROB1_COUNT,
                    REGISTER_STATUS_BILL_ROB2_BOOK: i.REGISTER_STATUS_BILL_ROB2_BOOK,
                    REGISTER_STATUS_BILL_ROB2_NO: i.REGISTER_STATUS_BILL_ROB2_NO,
                    REGISTER_STATUS_BILL_ROB2_COUNT: i.REGISTER_STATUS_BILL_ROB2_COUNT,
                    ROB_YEAR: i.ROB_YEAR,
                    REGISTER_STATUS_BILL_ROBFULL_NO: i.REGISTER_STATUS_BILL_ROBFULL_NO,
                    REGISTER_STATUS_BILL_ROBFULL_COUNT: i.REGISTER_STATUS_BILL_ROBFULL_COUNT,
                    CITIZEN: i.CITIZENT_LOGIN,
                    REGISTER_STATUS: i.REGISTER_STATUS,
                  });
                }
              }
            } else {
              if (i.Major1_LEVEL_OPEN_ID !== null) {
                dataMajor.push({
                  Major_LEVEL_OPEN_ID: i.Major1_LEVEL_OPEN_ID,
                  Major_LEVEL_OPEN_NAME: i.Major1_LEVEL_OPEN_NAME,
                  Major_MAJOR_CLASSROOM: i.Major1_MAJOR_CLASSROOM,
                  Major_MAJOR_CLASSROOM2: i.Major1_MAJOR_CLASSROOM2,
                  Major_MAJOR_CLASSROOM3: i.Major1_MAJOR_CLASSROOM3,
                  Major_MAJOR_ID: i.Major1_MAJOR_ID,
                  Major_MAJOR_NAME: i.Major1_MAJOR_NAME,
                  Major_course_year: i.Major1_course_year,
                  Major_course_year_id: i.Major1_course_year_id,
                  Major_course_year_name: i.Major1_course_year_name,
                  Major_faculty_name: i.Major1_faculty_name,
                  REGISTER_TYPE_ID: i.REGISTER_TYPE_ID,
                  REGISTER_ID: i.REGISTER_ID,
                  ROB_ID: i.ROB_ID,
                  REGISTER_STATUS_BILL_ROBFULL_BOOK: i.REGISTER_STATUS_BILL_ROBFULL_BOOK,
                  REGISTER_STATUS_BILL_ROB1_BOOK: i.REGISTER_STATUS_BILL_ROB1_BOOK,
                  REGISTER_STATUS_BILL_ROB1_NO: i.REGISTER_STATUS_BILL_ROB1_NO,
                  REGISTER_STATUS_BILL_ROB1_COUNT: i.REGISTER_STATUS_BILL_ROB1_COUNT,
                  REGISTER_STATUS_BILL_ROB2_BOOK: i.REGISTER_STATUS_BILL_ROB2_BOOK,
                  REGISTER_STATUS_BILL_ROB2_NO: i.REGISTER_STATUS_BILL_ROB2_NO,
                  REGISTER_STATUS_BILL_ROB2_COUNT: i.REGISTER_STATUS_BILL_ROB2_COUNT,
                  ROB_YEAR: i.ROB_YEAR,
                  REGISTER_STATUS_BILL_ROBFULL_NO: i.REGISTER_STATUS_BILL_ROBFULL_NO,
                  REGISTER_STATUS_BILL_ROBFULL_COUNT: i.REGISTER_STATUS_BILL_ROBFULL_COUNT,
                  CITIZEN: i.CITIZENT_LOGIN,
                  REGISTER_STATUS: i.REGISTER_STATUS,
                });
                if (i.Major2_LEVEL_OPEN_ID !== null) {
                  dataMajor.push({
                    Major_LEVEL_OPEN_ID: i.Major2_LEVEL_OPEN_ID,
                    Major_LEVEL_OPEN_NAME: i.Major2_LEVEL_OPEN_NAME,
                    Major_MAJOR_CLASSROOM: i.Major2_MAJOR_CLASSROOM,
                    Major_MAJOR_CLASSROOM2: i.Major2_MAJOR_CLASSROOM2,
                    Major_MAJOR_CLASSROOM3: i.Major2_MAJOR_CLASSROOM3,
                    Major_MAJOR_ID: i.Major2_MAJOR_ID,
                    Major_MAJOR_NAME: i.Major2_MAJOR_NAME,
                    Major_course_year: i.Major2_course_year,
                    Major_course_year_id: i.Major2_course_year_id,
                    Major_course_year_name: i.Major2_course_year_name,
                    Major_faculty_name: i.Major2_faculty_name,
                    REGISTER_TYPE_ID: i.REGISTER_TYPE_ID,
                    REGISTER_ID: i.REGISTER_ID,
                    ROB_ID: i.ROB_ID,
                    REGISTER_STATUS_BILL_ROBFULL_BOOK: i.REGISTER_STATUS_BILL_ROBFULL_BOOK,
                    REGISTER_STATUS_BILL_ROB1_BOOK: i.REGISTER_STATUS_BILL_ROB1_BOOK,
                    REGISTER_STATUS_BILL_ROB1_NO: i.REGISTER_STATUS_BILL_ROB1_NO,
                    REGISTER_STATUS_BILL_ROB1_COUNT: i.REGISTER_STATUS_BILL_ROB1_COUNT,
                    REGISTER_STATUS_BILL_ROB2_BOOK: i.REGISTER_STATUS_BILL_ROB2_BOOK,
                    REGISTER_STATUS_BILL_ROB2_NO: i.REGISTER_STATUS_BILL_ROB2_NO,
                    REGISTER_STATUS_BILL_ROB2_COUNT: i.REGISTER_STATUS_BILL_ROB2_COUNT,
                    ROB_YEAR: i.ROB_YEAR,
                    REGISTER_STATUS_BILL_ROBFULL_NO: i.REGISTER_STATUS_BILL_ROBFULL_NO,
                    REGISTER_STATUS_BILL_ROBFULL_COUNT: i.REGISTER_STATUS_BILL_ROBFULL_COUNT,
                    CITIZEN: i.CITIZENT_LOGIN,
                    REGISTER_STATUS: i.REGISTER_STATUS,
                  });
                }
              }
            }
          });
          const datatatatat = (id, reid, rob_id, major, status) => {
            const datata = dataMajor.filter(
              ({ REGISTER_TYPE_ID, REGISTER_ID }) => REGISTER_TYPE_ID === id && REGISTER_ID === reid
            );
            let column = [];

            if (rob_id === "147" || rob_id === "146") {
              if (status === "0") {
                column = [
                  {
                    label: "ลำดับที่",
                    field: "no",
                  },

                  {
                    label: "หลักสูตร",
                    field: "major",
                  },
                  // {
                  //   label: "รายละเอียด",
                  //   field: "day",
                  // },
                  // {
                  //   label: "สถานที่",
                  //   field: "place",
                  // },
                ];
              } else {
                column = [
                  {
                    label: "ลำดับที่",
                    field: "no",
                  },

                  {
                    label: "หลักสูตร",
                    field: "major",
                  },
                  {
                    label: "รายละเอียด",
                    field: "day",
                  },
                ];
              }
            } else if (status === "0" && (id === "1" || id === "5")) {
              column = [
                {
                  label: "ลำดับที่",
                  field: "no",
                },

                {
                  label: "หลักสูตร",
                  field: "major",
                },
              ];
            } else {
              if (rob_id === "148") {
                if (status === "2") {
                  column = [
                    {
                      label: "ลำดับที่",
                      field: "no",
                    },

                    {
                      label: "หลักสูตร",
                      field: "major",
                      minimal: "lg",
                    },
                    {
                      label: "รายละเอียด",
                      field: "day",
                    },
                  ];
                } else {
                  column = [
                    {
                      label: "ลำดับที่",
                      field: "no",
                    },

                    {
                      label: "หลักสูตร",
                      field: "major",
                      minimal: "lg",
                    },
                  ];
                }
              } else {
                if (rob_id === "131") {
                  if (status === "0") {
                    column = [
                      {
                        label: "ลำดับที่",
                        field: "no",
                      },

                      {
                        label: "หลักสูตร",
                        field: "major",
                        minimal: "lg",
                      },
                      // {
                      //   label: "รายละเอียด",
                      //   field: "day",
                      // },
                    ];
                  } else {
                    column = [
                      {
                        label: "ลำดับที่",
                        field: "no",
                      },

                      {
                        label: "หลักสูตร",
                        field: "major",
                        minimal: "lgksbp",
                      },
                      {
                        label: "รายละเอียด ",
                        field: "day",
                        minimal: "kssbp",
                      },
                    ];
                  }
                } else {
                  column = [
                    {
                      label: "ลำดับที่",
                      field: "no",
                    },

                    {
                      label: "หลักสูตร",
                      field: "major",
                      minimal: "lg",
                    },
                    {
                      label: "รายละเอียด",
                      field: "day",
                    },
                  ];
                }
              }
            }

            const table = {
              columns: column,
              rows: [
                ...datata.map((i, d) => ({
                  no: d + 1,

                  major: (
                    <Pane className="d-flex flex-column" minWidth="120px">
                      <Text>
                        {i.Major_LEVEL_OPEN_NAME} {i.Major_course_year_name}
                      </Text>
                      <Text>
                        {i.Major_MAJOR_ID} {i.Major_MAJOR_NAME}
                      </Text>
                    </Pane>
                  ),
                  day:
                    i.ROB_ID === "131" ? (
                      <>
                        <Text>
                          มหาวิทยาลัยฯ จะสอบสัมภาษณ์ผู้สมัครทางโทรศัพท์
                          โดยผู้สมัครไม่ต้องเดินทางมาสอบสัมภาษณ์ด้วยตนเองที่มหาวิทยาลัยฯ
                          {/* {i.Major_MAJOR_CLASSROOM}
                          <br />
                          {i.Major_MAJOR_CLASSROOM2}
                          <br />
                          {i.Major_MAJOR_CLASSROOM3} */}
                        </Text>
                        {/* <Text > */}
                        {/* <a className="text-primary" style={{ fontSize: 12 }} href={admission + "/public/news/1713427899.pdf"}>
                                  (คลิกเพื่อดูประกาศ เพื่อศึกษารายละเอียดและเตรียมเอกสารในการเข้ารับการสอบสัมภาษณ์)
                                </a> */}
                        {/* </Text> */}
                      </>
                    ) : i.ROB_ID === "148" ? (
                      ""
                    ) : i.ROB_ID === "147" || i.ROB_ID === "146" ? (
                      <>
                        {i.ROB_ID === "147" ? (
                          <>
                            {i.Major_faculty_name === "คณะครุศาสตร์" ||
                            i.Major_MAJOR_ID === "1110" ? (
                              <>
                                {i.Major1_MAJOR_ID === "1202" ||
                                i.Major1_MAJOR_ID === "1204" ||
                                i.Major1_MAJOR_ID === "1206" ||
                                i.Major1_MAJOR_ID === "1207" ||
                                i.Major1_MAJOR_ID === "1208" ? (
                                  <></>
                                ) : (
                                  <>
                                    <Badge
                                      color="blue"
                                      fontFamily=""
                                      fontSize={14}
                                      height="100%"
                                      padding={5}
                                    >
                                      {/* รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ วันที่ 10 เมษายน 2568 */}
                                      สอบสัมภาษณ์ : {i.Major_MAJOR_CLASSROOM}
                                    </Badge>

                                    <Badge
                                      marginTop={10}
                                      color="blue"
                                      fontFamily=""
                                      fontSize={14}
                                      height="100%"
                                      padding={5}
                                    >
                                      {/* รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ วันที่ 10 เมษายน 2568 */}
                                      สถานที่ : {i.Major_MAJOR_CLASSROOM2}
                                    </Badge>
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                {d === 1 ? (
                                  <>
                                    <Badge
                                      color="blue"
                                      fontFamily=""
                                      fontSize={14}
                                      height="100%"
                                      padding={5}
                                    >
                                      ไม่ต้องเข้ารับการสอบสัมภาษณ์
                                    </Badge>
                                  </>
                                ) : (
                                  <>
                                    <Badge
                                      color="blue"
                                      fontFamily=""
                                      fontSize={14}
                                      height="100%"
                                      padding={5}
                                    >
                                      {/* สอบสัมภาษณ์ทางโทรศัพท์ และระบบออนไลน์
                                      โดยไม่ต้องเดินทางมาที่มหาวิทยาลัยราชภัฏกำแพงเพชร */}
                                      มหาวิทยาลัยฯ จะสอบสัมภาษณ์ผู้สมัครทางโทรศัพท์ หรือระบบออนไลน์
                                      โดยผู้สมัครไม่ต้องเดินทางมาสอบสัมภาษณ์ด้วยตนเองที่มหาวิทยาลัยฯ
                                    </Badge>
                                  </>
                                )}
                              </>
                            )}
                          </>
                        ) : (
                          <>-</>
                          // 6701202045
                        )}
                      </>
                    ) : i.Major_LEVEL_OPEN_NAME !== "ครุศาสตรบัณฑิต" ||
                      i.REGISTER_TYPE_ID === "4" ||
                      i.REGISTER_TYPE_ID === "3" ||
                      i.REGISTER_TYPE_ID === "2" ||
                      i.REGISTER_TYPE_ID === "7" ? (
                      i.REGISTER_TYPE_ID !== "6" ? (
                        i.REGISTER_TYPE_ID === "1" || i.REGISTER_TYPE_ID === "5" ? (
                          i.ROB_ID !== "134" ||
                          i.ROB_ID !== "135" ||
                          i.ROB_ID !== "140" ||
                          i.ROB_ID !== "139" ||
                          i.ROB_ID !== "136" ? (
                            <>
                              {i.Major_MAJOR_ID === "1304" ? (
                                d === 0 ? (
                                  <>{i.Major_MAJOR_CLASSROOM}</>
                                ) : (
                                  <>
                                    {" "}
                                    <Text>วันเสาร์ที่ 17 กุมภาพันธ์ 2568 เวลา 13.00 น. </Text>
                                  </>
                                )
                              ) : (
                                <Pane display="flex" flexDirection="column">
                                  {i.ROB_ID === "139" ? (
                                    <>
                                      {d !== 1 ? (
                                        <>
                                          {" "}
                                          <Text>{i.Major_MAJOR_CLASSROOM}</Text>
                                        </>
                                      ) : i.Major_MAJOR_ID === "1304" ? (
                                        <>{i.Major_MAJOR_CLASSROOM}</>
                                      ) : (
                                        <>
                                          <Text>สาขาลำดับที่ 2 ไม่ต้องเข้ารับการสอบสัมภาษณ์</Text>
                                        </>
                                      )}{" "}
                                    </>
                                  ) : (
                                    <>
                                      {" "}
                                      <Text>ประกาศรายชื่อผู้ผ่านการคัดเลือก</Text>
                                    </>
                                  )}
                                  {d !== 1 ? (
                                    <>
                                      {i.ROB_ID === "139" ? (
                                        <></>
                                      ) : (
                                        <>
                                          <Link href=" https:admission.kpru.ac.th/admission">
                                            ที่เว็บไซต์ admission.kpru.ac.th
                                          </Link>
                                        </>
                                      )}

                                      {i.ROB_ID === "139" ? (
                                        <>
                                          {i.Major_MAJOR_ID !== "1304" ? (
                                            <></>
                                          ) : (
                                            <>
                                              {" "}
                                              <Text>วันที่ 14 ก.พ. 2568 - วันที่ 16 ก.พ. 2568</Text>
                                            </>
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          <Text>วันศุกร์ที่ 22 ธันวาคม 2566 เวลา 18.00 น.</Text>
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </Pane>
                              )}
                            </>
                          ) : i.ROB_ID === "137" || i.ROB_ID === "138" ? (
                            <>
                              {i.Major_MAJOR_ID === "1304" ? (
                                <>{i.Major_MAJOR_CLASSROOM}</>
                              ) : (
                                <>
                                  <Pane display="flex" flexDirection="column">
                                    <Text>ประกาศรายชื่อผู้ผ่านการคัดเลือก </Text>
                                    <Link href=" https:admission.kpru.ac.th/admission">
                                      ที่เว็บไซต์ admission.kpru.ac.th
                                    </Link>
                                    <Text>วันที่ 22 กุมภาพันธ์ 2568 เวลา 18.00 น. </Text>
                                  </Pane>
                                </>
                              )}
                            </>
                          ) : (
                            <Pane display="flex" flexDirection="column">
                              <Text>
                                {d === 0 ? (
                                  i.REGISTER_STATUS === "4" ||
                                  i.REGISTER_STATUS === "2" ||
                                  i.REGISTER_STATUS === "3" ? (
                                    <Pane display="flex" flexDirection="column">
                                      <Text>ประกาศรายชื่อผู้ผ่านการคัดเลือก </Text>
                                      <Link href=" https:admission.kpru.ac.th/admission">
                                        ที่เว็บไซต์ admission.kpru.ac.th
                                      </Link>
                                      <Text>วันศุกร์ที่ 22 ธันวาคม 2566 เวลา 18.00 น.</Text>
                                    </Pane>
                                  ) : i.ROB_ID !== "144" &&
                                    i.ROB_ID !== "139" &&
                                    i.ROB_ID !== "138" &&
                                    i.ROB_ID !== "137" ? (
                                    // <>{i.Major_MAJOR_CLASSROOM}  </>
                                    <> </>
                                  ) : i.ROB_ID === "144" && i.Major_MAJOR_ID === "1304" ? (
                                    // <>{i.Major_MAJOR_CLASSROOM}</>
                                    <>
                                      {i.Major_MAJOR_ID === "1304" ? (
                                        <>{i.Major_MAJOR_CLASSROOM}</>
                                      ) : (
                                        <>
                                          {" "}
                                          <Pane display="flex" flexDirection="column">
                                            <Text>ประกาศรายชื่อผู้มีสิทธิ์สอบสัมภาษณ์ </Text>
                                            <Link href=" https:admission.kpru.ac.th/admission">
                                              ที่เว็บไซต์ admission.kpru.ac.th
                                            </Link>
                                            <Text>วันที่ 14 ก.พ. 2568 - วันที่ 16 ก.พ. 2568 </Text>
                                          </Pane>
                                        </>
                                      )}{" "}
                                    </>
                                  ) : (
                                    <>
                                      {" "}
                                      <Pane display="flex" flexDirection="column">
                                        <Text>ประกาศรายชื่อผู้ผ่านการคัดเลือก </Text>
                                        <Link href=" https:admission.kpru.ac.th/admission">
                                          ที่เว็บไซต์ admission.kpru.ac.th
                                        </Link>
                                        <Text>วันพฤหัสบดีที่ 22 กุมภาพันธ์ 2568 เวลา 18.00 น.</Text>
                                      </Pane>
                                    </>
                                  )
                                ) : (
                                  <>
                                    {i.Major_MAJOR_ID === "1304"
                                      ? i.Major_MAJOR_CLASSROOM
                                      : "สาขาลำดับ 2 ไม่ต้องเข้ารับการสอบสัมภาษณ์"}
                                  </>
                                )}
                              </Text>
                            </Pane>
                          )
                        ) : i.REGISTER_TYPE_ID === "2" || i.REGISTER_TYPE_ID === "3" ? (
                          <Pane display="flex" flexDirection="column">
                            {i.REGISTER_STATUS !== "0" ? (
                              <>
                                {" "}
                                <Text>
                                  {i.Major_MAJOR_CLASSROOM}
                                  <br />
                                  {i.Major_MAJOR_CLASSROOM2}
                                  <br />
                                  {i.Major_MAJOR_CLASSROOM3}
                                </Text>
                                {/* <Text > */}
                                <a
                                  className="text-primary"
                                  style={{ fontSize: 12 }}
                                  href={admission + "/public/news/1713427899.pdf"}
                                >
                                  (คลิกเพื่อดูประกาศ
                                  เพื่อศึกษารายละเอียดและเตรียมเอกสารในการเข้ารับการสอบสัมภาษณ์)
                                </a>
                                {/* </Text> */}
                              </>
                            ) : (
                              ""
                            )}
                            {/* <Text>ประกาศรายชื่อผู้มีสิทธิ์สอบสัมภาษณ์ </Text>
                            <Text>วันศุกร์ ที่ 19 เม.ย. 2568 เวลา 18.00 น.</Text> */}
                          </Pane>
                        ) : i.REGISTER_TYPE_ID === "4" || i.REGISTER_TYPE_ID === "7" ? (
                          i.ROB_ID !== "145" ? (
                            <Text>
                              {i.Major_MAJOR_CLASSROOM}
                              <br />
                              {i.Major_MAJOR_CLASSROOM2}
                              <br />
                              {i.Major_MAJOR_CLASSROOM3}
                            </Text>
                          ) : (
                            <>
                              {i.ROB_ID === "145" ? (
                                <>
                                  <Pane display="flex" flexDirection="column">
                                    <Text>ประกาศรายชื่อผู้มีสิทธิ์สอบสัมภาษณ์ </Text>{" "}
                                    <Text>วันศุกร์ ที่ 10 พ.ค. 2568</Text>
                                  </Pane>
                                </>
                              ) : (
                                <></>
                              )}
                            </>
                          )
                        ) : (
                          "-"
                        )
                      ) : i.Major_MAJOR_ID === "9903" && parseInt(i.REGISTER_STATUS) >= 1 ? (
                        <>
                          <Text>
                            {i.Major_MAJOR_CLASSROOM}
                            <br />
                            {i.Major_MAJOR_CLASSROOM2}
                            <br />
                            {i.Major_MAJOR_CLASSROOM3}
                          </Text>
                        </>
                      ) : (
                        "-"
                      )
                    ) : (
                      <>
                        {i.ROB_ID === "134" || i.ROB_ID === "135" || i.ROB_ID === "136" ? (
                          <Pane display="flex" flexDirection="column">
                            <Text>ประกาศรายชื่อผู้ผ่านการคัดเลือก </Text>
                            <Link href=" https:admission.kpru.ac.th/admission">
                              ที่เว็บไซต์ admission.kpru.ac.th
                            </Link>
                            <Text>วันศุกร์ที่ 22 ธันวาคม 2566 เวลา 18.00 น.</Text>
                          </Pane>
                        ) : (
                          <>
                            <Pane display="flex" flexDirection="column">
                              <Pane display="flex" flexDirection="column">
                                {(i.ROB_ID === "139" ||
                                  i.ROB_ID === "138" ||
                                  i.ROB_ID === "137" ||
                                  i.ROB_ID === "144") &&
                                d !== 1 ? (
                                  <>
                                    {(i.ROB_ID === "138" || i.ROB_ID === "144") &&
                                    i.Major1_MAJOR_ID !== "1304" ? (
                                      <>
                                        ประกาศรายชื่อผู้ผ่านการคัดเลือก ที่เว็บไซต์
                                        admission.kpru.ac.th วันที่ 22 ก.พ. 2568 เวลา 18.00 น.
                                      </>
                                    ) : (
                                      <Text>
                                        {i.Major_MAJOR_CLASSROOM}
                                        <br />
                                        {/* {i.Major_MAJOR_CLASSROOM2} */}
                                        <br />
                                        {/* {i.Major_MAJOR_CLASSROOM3} */}
                                      </Text>
                                    )}
                                    {/* <Text>ประกาศรายชื่อผู้มีสิทธิ์สอบสัมภาษณ์</Text>{" "} */}
                                  </>
                                ) : (
                                  <>
                                    {" "}
                                    <Text>ประกาศรายชื่อผู้ผ่านการคัดเลือก </Text>
                                  </>
                                )}
                                {/* <Link href=" https:admission.kpru.ac.th/admission">
                                  ที่เว็บไซต์ admission.kpru.ac.th
                                </Link> */}
                                {/* {i.ROB_ID === "139" ? (
                                  <>
                                    <Text>วันที่ 14 ก.พ. 2568 - วันที่ 16 ก.พ. 2568</Text>{" "}
                                  </>
                                ) : i.ROB_ID === "144" ? (
                                  <>
                                    <Text>วันพฤหัสบดีที่ 22 กุมภาพันธ์ 2568 เวลา 18.00 น.</Text>
                                  </>
                                ) : (
                                  <>
                                    {" "}
                                    <Text>วันศุกร์ที่ 22 ธันวาคม 2566 เวลา 18.00 น.</Text>
                                  </>
                                )} */}
                              </Pane>
                            </Pane>
                          </>
                        )}
                      </>
                    ),

                  place:
                    i.ROB_ID === "147" || i.ROB_ID === "146" ? (
                      <>147</>
                    ) : i.Major_LEVEL_OPEN_NAME !== "ครุศาสตรบัณฑิต" ? (
                      i.REGISTER_TYPE_ID !== "4" ||
                      i.REGISTER_TYPE_ID !== "2" ||
                      i.REGISTER_TYPE_ID !== "3" ||
                      i.REGISTER_TYPE_ID !== "7" ? (
                        i.REGISTER_TYPE_ID !== "6" ? (
                          i.Major_MAJOR_ID !== "1304" ? (
                            <>
                              {i.ROB_ID === "139" ||
                              i.ROB_ID === "144" ||
                              i.ROB_ID === "136" ||
                              i.ROB_ID === "137" ||
                              i.ROB_ID === "138" ? (
                                <>
                                  {i.ROB_ID === "139" && d === 0 ? (
                                    <>{i.Major_MAJOR_CLASSROOM2}</>
                                  ) : (
                                    <></>
                                  )}
                                </>
                              ) : (
                                <>{d === 0 ? i.Major_MAJOR_CLASSROOM2 : ""}</>
                              )}
                            </>
                          ) : (
                            <>
                              {i.ROB_ID === "134" || i.ROB_ID === "135" || i.ROB_ID === "136" ? (
                                <>
                                  {i.Major_MAJOR_ID === "1304" ? (
                                    <>{i.Major_MAJOR_CLASSROOM2} </>
                                  ) : (
                                    ""
                                  )}
                                </>
                              ) : (
                                <>{i.Major_MAJOR_CLASSROOM2} </>
                              )}
                            </>
                          )
                        ) : (
                          "-"
                        )
                      ) : (
                        <></>
                      )
                    ) : (
                      <>
                        {i.Major_MAJOR_ID === "1304" ? (
                          <>
                            <Pane>{i.Major_MAJOR_CLASSROOM2} </Pane>
                          </>
                        ) : i.Major_LEVEL_OPEN_NAME === "ครุศาสตรบัณฑิต" &&
                          i.ROB_ID !== "134" &&
                          i.ROB_ID !== "137" &&
                          i.ROB_ID !== "138" &&
                          i.ROB_ID !== "135" &&
                          i.ROB_ID !== "136" ? (
                          i.ROB_ID === "144" ? (
                            <></>
                          ) : (
                            <Pane> {i.Major_MAJOR_CLASSROOM2}</Pane>
                          )
                        ) : (
                          <></>
                        )}
                      </>
                    ),
                })),
              ],
            };
            return table;
          };
          const datatatatatnu = (id, reid, rob) => {
            const datata = dataMajorNu
              // console.log(reid)
              .filter(
                ({ REGISTER_TYPE_ID, REGISTER_ID }) =>
                  REGISTER_TYPE_ID === id && REGISTER_ID === reid
              );
            let column = [];
            if (rob === "140" || rob === "147") {
              column = [
                {
                  label: "ลำดับที่",
                  field: "no",
                },
                {
                  label: "หลักสูตร",
                  field: "major",
                },
                // {
                //   label: "วันที่สอบสัมภาษณ์",
                //   field: "day",
                // },
                // {
                //   label: "สถานที่",
                //   field: "place",
                // },
              ];
            } else {
              column = [
                {
                  label: "ลำดับที่",
                  field: "no",
                },
                {
                  label: "หลักสูตร",
                  field: "major",
                },
                {
                  label: "วันที่สอบสัมภาษณ์",
                  field: "day",
                },
              ];
            }
            const tablenu = {
              columns: column,
              rows: [
                ...datata.map((i, d) => ({
                  no: d + 1,
                  major: (
                    <Pane className="d-flex flex-column" minWidth="120px">
                      <Text>
                        {i.Major_LEVEL_OPEN_NAME} {i.Major_course_year_name}
                      </Text>
                      <Text>
                        {i.Major_MAJOR_ID} {i.Major_MAJOR_NAME}
                      </Text>
                    </Pane>
                  ),
                  day: (
                    <Pane display="flex" flexDirection="column">
                      {d === 0 ? (
                        <>
                          {i.ROB_ID === "140" ? (
                            <>{i.Major_MAJOR_CLASSROOM} </>
                          ) : (
                            <>
                              ประกาศรายชื่อผู้มีสิทธิ์สอบสัมภาษณ์
                              <Link href=" https:admission.kpru.ac.th/admission">
                                ที่เว็บไซต์ admission.kpru.ac.th
                              </Link>
                              วันที่ 14 ก.พ. 2568 - วันที่ 16 ก.พ. 2568
                            </>
                          )}
                        </>
                      ) : (
                        <>สาขาลำดับที่ 2 ไม่ต้องเข้ารับการสอบสัมภาษณ์</>
                      )}
                    </Pane>
                  ),
                  place:
                    d === 0 ? (
                      <>
                        <Pane>
                          &nbsp;
                          {i.Major_MAJOR_CLASSROOM2}
                          <br /> {i.Major_MAJOR_CLASSROOM3}
                        </Pane>
                      </>
                    ) : (
                      <></>
                    ),
                  map: (
                    <>
                      {/* <Button
                      onClick={() => {
                        window.open(
                          mua + "/public/Files_All/map.pdf"
                        );
                      }}
                      appearance="primary"
                      intent="success"
                      iconBefore={<MapIcon />}
                    >
                      แผนผังที่นั่งสอบ
                    </Button> */}
                    </>
                  ),
                })),
              ],
            };
            return tablenu;
          };

          setDataRegister({
            columns: [
              {
                label: "ลำดับ",
                field: "no",
              },
              {
                label: "ปีการศึกษา",
                field: "robyear",
              },
              {
                label: "รอบการสมัคร",
                field: "rob",
              },
              {
                label: "รหัสผู้สมัคร",
                field: "register_id",
              },
              {
                label: "ชื่อ-นามสกุล",
                field: "register_name",
                minimal: "lg",
              },
              {
                label: "ใบรายงานผลการเรียน",
                field: "register_filevut",
                minimal: "lg",
              },
              {
                label: "สถานะ",
                field: "register_status",
                minimal: "lg",
              },
              {
                label: "จัดการ",
                field: "manage",
              },
            ],
            rows: [
              ...dataTrue.map((i, d) => ({
                no: d + 1,
                robyear: i.ROB_YEAR,
                register_id: i.REGISTER_ID,
                rob: i.QUOTA_NAME + " " + (i.ROB_NAME !== null ? i.ROB_NAME : ""),
                register_name: <Pane minWidth="200px"> {i.FULLNAME}</Pane>,
                register_filevut:
                  i.ROB_ID === "147" || i.ROB_ID === "146" ? (
                    <>
                      {i.REGISTER_STATUS === "0" || i.REGISTER_STATUS === "1" ? (
                        <>
                          {i.REGISTER_SENTVUT_REGISTER === "0" ? (
                            <>
                              <Badge
                                className="col-12"
                                fontFamily=""
                                fontSize={14}
                                fontWeight={500}
                                width="100%"
                                color="red"
                                padding={5}
                                height="100%"
                                justifyContent="start"
                                display="flex"
                                flexDirection="column"
                              >
                                <div>
                                  <AiOutlineFileExclamation size={16} fontWeight={700} />
                                  ใบรายงานผลการเรียนไม่ถูกต้อง{" "}
                                </div>
                                <div>กรุณาติดต่อ 055-706547 </div>
                              </Badge>
                              <Button
                                fontFamily=""
                                size="small"
                                iconBefore={<EyeOpenIcon />}
                                appearance="primary"
                                onClick={() => {
                                  window.open(
                                    mua + "/public/uploaddocument/" +
                                      localStorage.getItem("citizent") +
                                      "/" +
                                      localStorage.getItem("citizent") +
                                      "_2.pdf"
                                  );
                                }}
                              >
                                ตรวจสอบไฟล์
                              </Button>
                              <Button
                                disabled={i.REGISTER_SENTVUT_REGISTER === "1" ? true : false}
                                size="small"
                                appearance="views"
                                fontFamily=""
                                iconBefore={<EditIcon />}
                                className="btn-warning text-white"
                                onClick={() => {
                                  setIshowEditFile(true);
                                }}
                              >
                                อัพโหลดใหม่
                              </Button>
                            </>
                          ) : i.REGISTER_SENTVUT_REGISTER === "1" ? (
                            <Pane className="col-12 d-flex  flex-column">
                              <Badge
                                fontFamily=""
                                maxWidth="320px"
                                fontSize={14}
                                fontWeight={500}
                                width="100%"
                                color="green"
                                padding={5}
                                height="100%"
                                justifyContent="start"
                                display="flex"
                              >
                                <AiOutlineFileDone size={16} fontWeight={700} />
                                การอัพโหลดใบรายงานผลการเรียนผ่านการตรวจสอบ
                              </Badge>
                            </Pane>
                          ) : i.Major1_faculty_name === "คณะครุศาสตร์" ||
                            i.Major1_MAJOR_ID === "1106" ? (
                            <>
                              <Badge
                                fontFamily=""
                                fontSize={14}
                                fontWeight={500}
                                maxWidth="320px"
                                width="100%"
                                color="yellow"
                                padding={5}
                                height="100%"
                                justifyContent="start"
                                display="flex"
                              >
                                <AiOutlineFileSearch size={16} fontWeight={700} />
                                รอการตรวจสอบใบรายงานผลการเรียน
                              </Badge>
                              <Button
                                fontFamily=""
                                size="small"
                                iconBefore={<EyeOpenIcon />}
                                appearance="primary"
                                onClick={() => {
                                  window.open(
                                    mua + "/public/uploaddocument/" +
                                      localStorage.getItem("citizent") +
                                      "/" +
                                      localStorage.getItem("citizent") +
                                      "_2.pdf"
                                  );
                                }}
                              >
                                ตรวจสอบไฟล์
                              </Button>
                            </>
                          ) : (
                            <>
                              <Button
                                fontFamily=""
                                size="small"
                                iconBefore={<EyeOpenIcon />}
                                appearance="primary"
                                onClick={() => {
                                  window.open(
                                    mua + "/public/uploaddocument/" +
                                      localStorage.getItem("citizent") +
                                      "/" +
                                      localStorage.getItem("citizent") +
                                      "_2.pdf"
                                  );
                                }}
                              >
                                ตรวจสอบไฟล์
                              </Button>
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          <Pane className="col-12 d-flex  flex-column">
                            <Badge
                              fontFamily=""
                              maxWidth="320px"
                              fontSize={14}
                              fontWeight={500}
                              width="100%"
                              color="green"
                              padding={5}
                              height="100%"
                              justifyContent="start"
                              display="flex"
                            >
                              <AiOutlineFileDone size={16} fontWeight={700} />
                              การอัพโหลดใบรายงานผลการเรียนผ่านการตรวจสอบ
                            </Badge>
                          </Pane>
                        </>
                      )}
                    </>
                  ) : i.Major1_MAJOR_ID !== "9903" ? (
                    <Pane
                      display="flex"
                      flexWrap="wrap"
                      gap="5px"
                      justifyContent="center"
                      minWidth="200px"
                    >
                      {/* {i.REGISTER_SENTVUT_REGISTER ==="1"? "1":i.REGISTER_SENTVUT_REGISTER === "2"? "2":"0" } */}
                      {
                        // i.Major1_MAJOR_ID === "9902x" &&
                        (i.Major1_LEVEL_OPEN_NAME === "ครุศาสตรบัณฑิต" ||
                          i.Major1_MAJOR_ID === "1106") &&
                        i.QUOTA_ID !== "1" &&
                        i.ROB_ID !== "139" ? (
                          <>
                            {i.REGISTER_SENTVUT_REGISTER === "1" ? <></> : <></>}
                            <Pane className="col-12 d-flex  flex-column">
                              <Badge
                                fontFamily=""
                                maxWidth="320px"
                                fontSize={14}
                                fontWeight={500}
                                width="100%"
                                color="green"
                                padding={5}
                                height="100%"
                                justifyContent="start"
                                display="flex"
                              >
                                <AiOutlineFileDone size={16} fontWeight={700} />
                                การอัพโหลดใบรายงานผลการเรียนผ่านการตรวจสอบ
                              </Badge>
                            </Pane>
                          </>
                        ) : (
                          <>
                            {i.QUOTA_ID !== "1" ? (
                              <>
                                <Button
                                  fontFamily=""
                                  size="small"
                                  iconBefore={<EyeOpenIcon />}
                                  appearance="primary"
                                  onClick={() => {
                                    window.open(
                                      mua + "/public/uploaddocument/" +
                                        localStorage.getItem("citizent") +
                                        "/" +
                                        localStorage.getItem("citizent") +
                                        "_2.pdf"
                                    );
                                  }}
                                >
                                  ดูไฟล์
                                </Button>
                                {i.REGISTER_SENTVUT_REGISTER === "1" ||
                                (i.REGISTER_SENTVUT_REGISTER === "0" &&
                                  (i.ROB_ID === "139" || i.ROB_ID === "140")) ||
                                !(
                                  i.Major1_LEVEL_OPEN_NAME === "ครุศาสตรบัณฑิต" ||
                                  i.Major1_MAJOR_ID === "1106" ||
                                  i.REGISTER_SENTVUT_REGISTER !== null
                                ) ? (
                                  <></>
                                ) : (
                                  <>
                                    {" "}
                                    <Button
                                      disabled={i.REGISTER_SENTVUT_REGISTER === "1" ? true : false}
                                      size="small"
                                      appearance="views"
                                      fontFamily=""
                                      iconBefore={<EditIcon />}
                                      className="btn-warning text-white"
                                      onClick={() => {
                                        setIshowEditFile(true);
                                      }}
                                    >
                                      แก้ไข {i.REGISTER_SENTVUT_REGISTER}
                                    </Button>
                                  </>
                                )}

                                {i.REGISTER_SENTVUT_REGISTER === "0" ? (
                                  <Badge
                                    className="col-12"
                                    fontFamily=""
                                    fontSize={14}
                                    fontWeight={500}
                                    width="60px"
                                    color="red"
                                    padding={5}
                                    height="100%"
                                    justifyContent="start"
                                    display="flex"
                                    flexDirection="column"
                                  >
                                    <div>
                                      <AiOutlineFileExclamation size={16} fontWeight={700} />
                                      ใบรายงานผลการเรียนไม่ถูกต้อง{" "}
                                    </div>
                                    <div>กรุณาติดต่อ 055-706547 </div>
                                  </Badge>
                                ) : i.REGISTER_SENTVUT_REGISTER === "1" ? (
                                  <Pane className="col-12 d-flex  flex-column">
                                    <Badge
                                      fontFamily=""
                                      maxWidth="320px"
                                      fontSize={14}
                                      fontWeight={500}
                                      width="100%"
                                      color="green"
                                      padding={5}
                                      height="100%"
                                      justifyContent="start"
                                      display="flex"
                                    >
                                      <AiOutlineFileDone size={16} fontWeight={700} />
                                      การอัพโหลดใบรายงานผลการเรียนผ่านการตรวจสอบ
                                    </Badge>
                                  </Pane>
                                ) : i.REGISTER_SENTVUT_REGISTER === null ? (
                                  <Pane className="col-12 d-flex  flex-column">
                                    {i.Major1_LEVEL_OPEN_NAME === "ครุศาสตรบัณฑิต" ||
                                    i.Major1_MAJOR_ID === "1106" ? (
                                      <>
                                        <Badge
                                          fontFamily=""
                                          // className="col-12"
                                          fontSize={14}
                                          fontWeight={500}
                                          maxWidth="320px"
                                          width="100%"
                                          color="yellow"
                                          padding={5}
                                          height="100%"
                                          justifyContent="start"
                                          display="flex"
                                        >
                                          <AiOutlineFileSearch size={16} fontWeight={700} />
                                          รอการตรวจสอบใบรายงานผลการเรียน
                                        </Badge>
                                      </>
                                    ) : (
                                      <>
                                        <Badge
                                          fontFamily=""
                                          maxWidth="320px"
                                          // className="col-12"
                                          fontSize={14}
                                          fontWeight={500}
                                          width="100%"
                                          color="green"
                                          padding={5}
                                          height="100%"
                                          justifyContent="start"
                                          display="flex"
                                        >
                                          <AiOutlineFileDone size={16} fontWeight={700} />
                                          การอัพโหลดใบรายงานผลการเรียนผ่านการตรวจสอบ
                                        </Badge>
                                      </>
                                    )}
                                  </Pane>
                                ) : (
                                  <></>
                                )}
                              </>
                            ) : (
                              <></>
                            )}
                          </>
                        )
                      }
                    </Pane>
                  ) : (
                    <></>
                  ),
                register_status:
                  i.ROB_ID === "148" ? (
                    <>
                      {i.REGISTER_STATUS === "0" ? (
                        <>
                          <Badge
                            color="yellow"
                            padding={5}
                            fontFamily=""
                            fontSize={14}
                            height="100%"
                          >
                            <FaMoneyBills /> อยู่ระหว่างการชำระค่าสมัคร
                          </Badge>
                        </>
                      ) : i.REGISTER_STATUS === "1" ? (
                        <>
                          <Text color="blue">
                            มหาวิทยาลัยฯ จะสอบสัมภาษณ์ผู้สมัครทางโทรศัพท์ หรือระบบออนไลน์
                            โดยผู้สมัครไม่ต้องเดินทางมาสอบสัมภาษณ์ด้วยตนเองที่มหาวิทยาลัยฯ
                          </Text>
                        </>
                      ) : i.REGISTER_STATUS === "4" ? (
                        <Badge color="green" height="100%" padding={5} fontFamily="" fontSize={14}>
                          ผ่านการคัดเลือก
                          {i.QUOTA_NAME} {i.ROB_NAME} {i.Major1_faculty_name} หลักสูตร
                          {i.Major1_LEVEL_OPEN_NAME} {i.Major1_MAJOR_ID} :{i.Major1_MAJOR_NAME}
                        </Badge>
                      ) : (
                        <></>
                      )}
                      <MDBDataTableV5
                        theadColor="deep-purple"
                        theadTextWhite
                        responsive
                        searching={false}
                        displayEntries={false}
                        bordered
                        borderless={false}
                        data={
                          i.Major1_MAJOR_ID === "9902"
                            ? datatatatatnu(i.REGISTER_TYPE_ID, i.REGISTER_ID, i.ROB_ID)
                            : datatatatat(
                                i.REGISTER_TYPE_ID,
                                i.REGISTER_ID,
                                i.ROB_ID,
                                i.Major1_MAJOR_ID,
                                i.REGISTER_STATUS
                              )
                        }
                      />
                      {i.REGISTER_STATUS === "1" ? (
                        <>
                          <Text>*หมายเหตุ </Text>
                          <br />
                          <Text>
                            คณะครุศาสตร์ทุกสาขาวิชา และหลักสูตรควบระดับปริญญาตรีสองปริญญา
                            สาขาวิชาคณิตศาสตร์ประยุกต์ เตรียม Portfolio ในการสอบสัมภาษณ์
                          </Text>
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  ) : (
                    <Pane minWidth="150px">
                      {i.REGISTER_STATUS === "0" ? (
                        <Pane>
                          {i.ROB_ID === "139" ||
                          i.ROB_ID === "140" ||
                          i.ROB_ID === "144" ||
                          i.ROB_ID === "138" ||
                          i.ROB_ID === "137" ||
                          i.ROB_ID === "133" ? (
                            <></>
                          ) : (
                            <Badge
                              color="yellow"
                              padding={5}
                              fontFamily=""
                              fontSize={14}
                              height="100%"
                            >
                              <FaMoneyBills /> อยู่ระหว่างการชำระค่าสมัคร
                            </Badge>
                          )}
                        </Pane>
                      ) : i.REGISTER_STATUS === "1" ? (
                        <>
                          {i.ROB_ID === "147" ? (
                            <>
                              {/* {i.Major1_faculty_name === "คณะครุศาสตร์" ? (
                              <Badge color="yellow" height="100%" padding={5}>
                                รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                              </Badge>
                            ) : (
                              <Badge></Badge>
                            )} */}
                              <Badge
                                color="green"
                                size={"xl"}
                                fontSize={14}
                                height="100%"
                                fontFamily=""
                              >
                                <FaReceipt /> ชำระค่าสมัครแล้ว
                              </Badge>
                            </>
                          ) : i.ROB_ID === "146" ? (
                            <>
                              <Badge
                                color="green"
                                padding={5}
                                fontFamily=""
                                fontSize={14}
                                height="100%"
                              >
                                <AiFillCheckCircle /> ผ่านการคัดเลือก
                                {i.QUOTA_NAME} {i.ROB_NAME} {i.Major1_faculty_name} หลักสูตร
                                {i.Major1_LEVEL_OPEN_NAME} {i.Major1_MAJOR_ID} :
                                {i.Major1_MAJOR_NAME}
                              </Badge>
                            </>
                          ) : (
                            <></>
                          )}
                          {i.REGISTER_TYPE_ID === "4" ||
                          i.REGISTER_TYPE_ID === "6" ||
                          i.REGISTER_TYPE_ID === "7" ||
                          i.REGISTER_TYPE_ID === "2" ||
                          i.REGISTER_TYPE_ID === "3" ? (
                            <>
                              {
                                // i.REGISTER_TYPE_ID === "4" &&

                                i.ROB_ID === "133" ? (
                                  <>
                                    <Badge
                                      color="green"
                                      padding={5}
                                      fontFamily=""
                                      fontSize={14}
                                      height="100%"
                                    >
                                      <BiCheck /> ประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                                    </Badge>
                                  </>
                                ) : i.ROB_ID === "131" ? (
                                  i.REGISTER_STATUS === "1" ? (
                                    <>
                                      <Badge
                                        color="green"
                                        padding={5}
                                        fontFamily=""
                                        fontSize={14}
                                        height="100%"
                                      >
                                        <AiFillCheckCircle /> มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                                      </Badge>
                                    </>
                                  ) : (
                                    <>
                                      <Badge
                                        color="green"
                                        padding={5}
                                        fontFamily=""
                                        fontSize={14}
                                        height="100%"
                                      >
                                        <BiCheck /> ประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                                      </Badge>
                                    </>
                                  )
                                ) : (
                                  <>
                                    {/* <Badge color="yellow" padding={5} fontFamily="" fontSize={14} height="100%">
                                      <TimeIcon /> รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบวัดความรู้ 
                                    </Badge>
                                    <br />
                                    <Badge className="text-info">วันที่ 8 พฤษภาคม 2568</Badge> */}
                                  </>
                                )
                              }
                            </>
                          ) : (
                            <>
                              {" "}
                              {i.ROB_ID === "134" || i.ROB_ID === "135" || i.ROB_ID === "136" ? (
                                <>
                                  {i.Major1_MAJOR_ID === "1304" ? (
                                    <>
                                      {" "}
                                      <Badge
                                        color="green"
                                        padding={5}
                                        fontFamily=""
                                        fontSize={14}
                                        height="100%"
                                      >
                                        <AiFillCheckCircle /> มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                                      </Badge>
                                    </>
                                  ) : (
                                    <>
                                      <Badge
                                        color="green"
                                        padding={5}
                                        fontFamily=""
                                        fontSize={14}
                                        height="100%"
                                      >
                                        <AiFillCheckCircle /> เข้ารับการสอบสัมภาษณ์แล้ว
                                      </Badge>
                                    </>
                                  )}
                                </>
                              ) : (i.ROB_ID === "137" || i.ROB_ID === "138") &&
                                i.Major1_MAJOR_ID !== "1304" ? (
                                <>
                                  <Pane>
                                    {i.Major1_MAJOR_ID === "1304" ? (
                                      <>
                                        <Badge
                                          color="yellow"
                                          padding={5}
                                          fontFamily=""
                                          fontSize={14}
                                          height="100%"
                                        >
                                          <AiFillCheckCircle />{" "}
                                          รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                                        </Badge>
                                      </>
                                    ) : (
                                      <Badge
                                        color="green"
                                        padding={5}
                                        fontFamily=""
                                        fontSize={14}
                                        height="100%"
                                      >
                                        รอประกาศรายชื่อผู้ผ่านคัดเลือก
                                      </Badge>
                                    )}
                                  </Pane>
                                </>
                              ) : i.Major1_MAJOR_ID !== "1304" ? (
                                <>
                                  {i.ROB_ID === "139" ? (
                                    <>
                                      {" "}
                                      {i.ROB_ID === "139" || i.ROB_ID === "140" ? (
                                        <Badge
                                          color="red"
                                          padding={5}
                                          fontFamily=""
                                          fontSize={14}
                                          height="100%"
                                        >
                                          <AiFillCheckCircle />
                                          ไม่เข้ารับการสอบสัมภาษณ์
                                        </Badge>
                                      ) : (
                                        ""
                                      )}
                                    </>
                                  ) : i.ROB_ID === "144" ? (
                                    <Badge
                                      color="green"
                                      padding={5}
                                      fontFamily=""
                                      fontSize={14}
                                      height="100%"
                                    >
                                      <FaMoneyBills /> รอประกาศรายชื่อผู้ผ่านคัดเลือก
                                    </Badge>
                                  ) : i.ROB_ID === "140" ? (
                                    <>
                                      {" "}
                                      <Badge
                                        color="red"
                                        padding={5}
                                        fontFamily=""
                                        fontSize={14}
                                        height="100%"
                                      >
                                        <AiFillCheckCircle />
                                        ไม่เข้ารับการสอบสัมภาษณ์
                                      </Badge>
                                    </>
                                  ) : (
                                    <></>
                                    // <Badge color="green" padding={5} fontFamily="" fontSize={14} height="100%">
                                    //   <AiFillCheckCircle />
                                    //   มีสิทธิ์เข้ารับการสอบสัมภาษณ์ อเดกเ
                                    // </Badge>
                                  )}
                                </>
                              ) : i.ROB_ID === "140" ? (
                                <>
                                  <Badge
                                    color="yellow"
                                    padding={5}
                                    fontFamily=""
                                    fontSize={14}
                                    height="100%"
                                  >
                                    <AiFillCheckCircle />{" "}
                                    รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                                  </Badge>
                                </>
                              ) : (i.ROB_ID === "139" ||
                                  i.ROB_ID === "144" ||
                                  i.ROB_ID === "138" ||
                                  i.ROB_ID === "137") &&
                                i.Major1_MAJOR_ID === "1304" ? (
                                <>
                                  <Badge
                                    color="green"
                                    padding={5}
                                    fontFamily=""
                                    fontSize={14}
                                    height="100%"
                                  >
                                    <AiFillCheckCircle />
                                    มีสิทธิ์เข้ารับการสอบสัมภาษณ์
                                  </Badge>
                                </>
                              ) : i.ROB_ID !== "144" ? (
                                <>
                                  <Badge
                                    color="red"
                                    padding={5}
                                    fontFamily=""
                                    fontSize={14}
                                    height="100%"
                                  >
                                    <AiFillCheckCircle /> ไม่เข้ารับการสอบสัมภาษณ์
                                  </Badge>
                                </>
                              ) : i.ROB_ID === "144" ? (
                                <></>
                              ) : (
                                <></>
                              )}
                            </>
                          )}
                          {/* {} */}
                        </>
                      ) : i.REGISTER_STATUS === "2" ? (
                        <>
                          {i.ROB_ID === "131" ? (
                            <></>
                          ) : i.ROB_ID === "147" ? (
                            <>
                              {" "}
                              <Badge
                                color="yellow"
                                padding={5}
                                fontFamily=""
                                fontSize={14}
                                height="100%"
                              >
                                รอประกาศรายชื่อผู้ผ่านการคัดเลือกตัวจริง และตัวสำรอง
                              </Badge>
                            </>
                          ) : (
                            <Badge
                              color="blue"
                              padding={5}
                              fontFamily=""
                              fontSize={14}
                              height="100%"
                            >
                              <AiFillCheckCircle /> เข้ารับการสอบสัมภาษณ์
                            </Badge>
                          )}
                        </>
                      ) : i.REGISTER_STATUS === "3" ? (
                        <Pane>
                          {i.REGISTER_ID === "6709902330" || i.REGISTER_ID === "6709902270" ? (
                            <>
                              <Badge
                                fontSize={14}
                                color="blue"
                                height="100%"
                                padding={5}
                                fontFamily=""
                              >
                                ผ่านการคัดเลือก (ตัวจริง) พยาบาลศาสตรบัณฑิต 2
                                คณะพยาบาลศาสตร์หลักสูตรพยาบาลศาสตรบัณฑิต 9902 : สาขาวิชาพยาบาลศาสตร์
                              </Badge>
                              <Badge
                                marginTop={10}
                                color="yellow"
                                fontSize={14}
                                height="100%"
                                padding={5}
                                fontFamily=""
                              >
                                ส่งผลการตรวจร่างกาย ณ อาคารคณะพยาบาลศาสตร์
                                มหาวิทยาลัยราชภัฏกำแพงเพชร (ตัวจริง) ตั้งแต่วันนี้ ถึงวันศุกร์ที่ 15
                                มีนาคม 2568
                              </Badge>
                            </>
                          ) : (
                            <>
                              {i.REGISTER_ORDER !== "" &&
                              i.REGISTER_ORDER !== undefined &&
                              i.REGISTER_ORDER !== null ? (
                                <>
                                  <Badge
                                    color="red"
                                    padding={5}
                                    fontFamily=""
                                    fontSize={14}
                                    height="100%"
                                  >
                                    <AiFillFile />
                                    ไม่ผ่านการคัดเลือก {i.QUOTA_NAME} {i.ROB_NAME} &nbsp;
                                    {i.Major1_faculty_name} หลักสูตร
                                    {i.Major1_LEVEL_OPEN_NAME} {i.Major1_MAJOR_ID} :
                                    {i.Major1_MAJOR_NAME}
                                    {/* {i.REGISTER_ORDER1 !== "" && i.REGISTER_ORDER1 !== undefined && i.REGISTER_ORDER1 !== null ? (
                                <>{i.REGISTER_ORDER1}</>
                              ) : (
                                <></>
                              )} */}
                                  </Badge>
                                  {/* <div>*หมายเหตุ</div>

                                <div>1. ประกาศผลการคัดเลือก (ตัวสำรอง) วันที่ 12 มีนาคม 2568</div> */}
                                </>
                              ) : (
                                <>
                                  <Badge
                                    color="red"
                                    padding={5}
                                    fontFamily=""
                                    fontSize={14}
                                    height="100%"
                                  >
                                    <AiFillCloseCircle /> ไม่ผ่านการคัดเลือก {i.QUOTA_NAME}{" "}
                                    {i.ROB_NAME} &nbsp;
                                    {i.Major1_faculty_name} หลักสูตร
                                    {i.Major1_LEVEL_OPEN_NAME} {i.Major1_MAJOR_ID} :
                                    {i.Major1_MAJOR_NAME}
                                  </Badge>
                                  {/* <Pane paddingTop={10} display="flex" flexDirection="column">
                                    <div>หมายเหตุ*</div>
                                    <div>เปิดรับสมัครภาคปกติ รอบ 3 วันที่ 6 มีนาคม - 10 พฤษภาคม 2568</div>
                                  </Pane> */}
                                </>
                              )}
                            </>
                          )}
                        </Pane>
                      ) : i.REGISTER_STATUS === "4" ? (
                        i.Major1_MAJOR_ID !== "9902" ? (
                          <Pane minWidth={800} className="" display="flex" flexDirection="column">
                            <>
                              <Badge
                                color="green"
                                padding={5}
                                fontFamily=""
                                fontSize={12}
                                height="100%"
                              >
                                <AiFillCheckCircle /> ผู้มีสิทธิ์เข้าศึกษาต่อ
                                {i.QUOTA_NAME} {i.Major1_faculty_name} หลักสูตร
                                {i.Major1_LEVEL_OPEN_NAME} {i.Major1_MAJOR_ID}{" "}
                                {i.Major1_MAJOR_ID !== "9903" ? "" : " : " + i.Major1_MAJOR_NAME}
                              </Badge>
                              {i.Major1_MAJOR_ID === "9903" ? (
                                <>
                                  <Pane paddingTop={10} display="flex" flexDirection="column">
                                    <b>*หมายเหตุ</b>
                                    <div>
                                      {" "}
                                      1.
                                      ผู้มีสิทธิ์เข้าศึกษาหลักสูตรประกาศนียบัตรบัณฑิตผู้ช่วยพยาบาล
                                      ยืนยันสิทธิ์พร้อมพิมพ์ใบชำระเงิน ภายในวันที่ 5 กรกฎาคม พ.ศ.
                                      2568 ถ้าพ้นกำหนด
                                      จะถือว่าสละสิทธิ์ในการเข้าเป็นนักศึกษาของมหาวิทยาลัยราชภัฏกำแพงเพชร
                                    </div>
                                  </Pane>
                                </>
                              ) : (
                                ""
                              )}

                              {i.Major1_MAJOR_ID === "1202" ||
                              i.Major1_MAJOR_ID === "1204" ||
                              i.Major1_MAJOR_ID === "1206" ||
                              i.Major1_MAJOR_ID === "1207" ||
                              i.Major1_MAJOR_ID === "1208" ? (
                                <>
                                  <Pane paddingTop={10} display="flex" flexDirection="column">
                                    <b>*หมายเหตุ</b>
                                    <div>
                                      {" "}
                                      1. ผู้ผ่านการคัดเลือก (ตัวจริง)
                                      สามารถยืนยันสิทธิ์และชำระค่าธรรมเนียมการศึกษาได้ ตั้งแต่วันที่
                                      24 - 28 เมษายน 2568
                                    </div>
                                  </Pane>
                                </>
                              ) : (
                                <>
                                  {i.ROB_ID === "131" ? (
                                    <>
                                      {" "}
                                      <Pane paddingTop={10} display="flex" flexDirection="column">
                                        <b>*หมายเหตุ</b>
                                        <div>
                                          {" "}
                                          1. ให้ผู้ผ่านการคัดเลือกคลิกดูประกาศ
                                          เพื่อศึกษารายละเอียดและขั้นตอนในการเข้าเป็นนักศึกษาของมหาวิทยาลัยฯ
                                        </div>
                                        <div>
                                          {" "}
                                          2. ผู้ผ่านการคัดเลือก
                                          สามารถยืนยันสิทธิ์และชำระค่าธรรมเนียมการศึกษาได้
                                          ตั้งแต่วันที่ 27 - 31 พฤษภาคม 2568
                                        </div>
                                        <div>
                                          {" "}
                                          3. กรอกข้อมูลและอัปโหลดเอกสารการรายงานตัว ระหว่างวันที่ 27
                                          พฤษภาคม - 7 มิถุนายน 2568
                                        </div>
                                      </Pane>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </>
                              )}
                            </>
                            {/* ) : ( */}
                            <>
                              {/* {i.ROB_ID === "1206"} */}
                              {/* <Badge color="yellow" padding={5} fontFamily="" fontSize={14} height="100%">
                                รอประกาศรายชื่อผู้ผ่านการคัดเลือกตัวจริง และตัวสำรอง หลักสูตร
                                {i.Major1_LEVEL_OPEN_NAME} {i.Major1_MAJOR_ID} :{i.Major1_MAJOR_NAME}
                              </Badge> */}
                            </>
                            {/* )} */}

                            {i.REGISTER_ORDER !== "" &&
                            i.REGISTER_ORDER !== null &&
                            i.REGISTER_ORDER !== undefined &&
                            i.REGISTER_ID !== "6701205077" &&
                            i.REGISTER_ID !== "6701205061" &&
                            i.REGISTER_ID !== "6701205129" &&
                            i.REGISTER_ID !== "6701205124" ? (
                              <>
                                {" "}
                                {/* <Badge color="blue" padding={5} fontFamily="" fontSize={14} height="100%"> */}
                                {/* <AiFillCheckCircle /> */}
                                {/* ผ่านการคัดเลือกเป็น{i.REGISTER_ORDER} */}
                                {/* </Badge> */}
                                {i.Major1_MAJOR_ID === "9902" ? (
                                  <></>
                                ) : (
                                  <>
                                    {i.QUOTA_ID !== "4" ? (
                                      ""
                                    ) : (
                                      <Pane paddingTop={10} display="flex" flexDirection="column">
                                        <b>*หมายเหตุ</b>
                                        <div>
                                          {" "}
                                          1. ผู้ผ่านการคัดเลือก (ตัวจริง)
                                          สามารถยืนยันสิทธิ์และชำระค่าธรรมเนียมการศึกษาได้
                                          ตั้งแต่วันที่ 22 - 29 กุมภาพันธ์ 2568
                                        </div>
                                        {i.ROB_ID !== "134" &&
                                        i.ROB_ID !== "135" &&
                                        i.ROB_ID !== "136" ? (
                                          <div>
                                            2. ประกาศผลการคัดเลือก (ตัวสำรอง) วันที่ 2 มีนาคม 2568
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                        {/* {i.ROB_ID !== "134" &&
                                    i.ROB_ID !== "135" &&
                                    i.ROB_ID !== "136" ? (
                                      <div>
                                        2. ประกาศผลการคัดเลือก (ตัวสำรอง) วันที่
                                        5 มกราคม 2568
                                      </div>
                                    ) : (
                                      ""
                                    )} */}
                                      </Pane>
                                    )}
                                  </>
                                )}
                                {i.ROB_ID === "140" && i.Major1_MAJOR_ID === "9902" ? (
                                  ""
                                ) : i.ROB_ID === "140" ? (
                                  <Pane paddingTop={10} display="flex" flexDirection="column">
                                    <b>*หมายเหตุ</b>
                                    <div>
                                      {" "}
                                      1. ผู้ผ่านการคัดเลือก (ตัวจริง)
                                      สามารถยืนยันสิทธิ์และชำระค่าธรรมเนียมการศึกษาได้ ตั้งแต่วันที่
                                      22 - 29 กุมภาพันธ์ 2568
                                    </div>
                                    <div>
                                      2. ประกาศผลการคัดเลือก (ตัวสำรอง) วันที่ 12 มีนาคม 2568{" "}
                                    </div>
                                  </Pane>
                                ) : (
                                  ""
                                )}
                              </>
                            ) : (
                              <>
                                {i.Major1_MAJOR_ID === "9902" ? (
                                  <></>
                                ) : i.ROB_ID === "133" ? (
                                  <>
                                    <Pane paddingTop={10} display="flex" flexDirection="column">
                                      <b>
                                        {" "}
                                        {
                                          (
                                            dataTitle.find(
                                              (val) => val.major_id === i.Major1_MAJOR_ID
                                            ) || {}
                                          ).text1
                                        }
                                      </b>
                                      <div>
                                        {
                                          (
                                            dataTitle.find(
                                              (val) => val.major_id === i.Major1_MAJOR_ID
                                            ) || {}
                                          ).text2
                                        }
                                      </div>
                                      <div>
                                        {
                                          (
                                            dataTitle.find(
                                              (val) => val.major_id === i.Major1_MAJOR_ID
                                            ) || {}
                                          ).text3
                                        }
                                      </div>
                                    </Pane>
                                  </>
                                ) : (
                                  <>
                                    {i.QUOTA_ID === "4" ? (
                                      <Pane paddingTop={10} display="flex" flexDirection="column">
                                        <b>*หมายเหตุ</b>
                                        {i.REGISTER_ID !== "6701205077" &&
                                        i.REGISTER_ID !== "6701205061" &&
                                        i.REGISTER_ID !== "6701205129" &&
                                        i.REGISTER_ID !== "6701205124" ? (
                                          <>
                                            <div>
                                              1. ผู้ผ่านการคัดเลือก (ตัวจริง)
                                              สามารถยืนยันสิทธิ์และชำระค่าธรรมเนียมการศึกษาได้
                                              ตั้งแต่วันที่ 22 - 29 กุมภาพันธ์ 2568
                                            </div>
                                            {i.ROB_ID !== "134" &&
                                            i.ROB_ID !== "135" &&
                                            i.ROB_ID !== "136" ? (
                                              <div>
                                                2. ประกาศผลการคัดเลือก (ตัวสำรอง) วันที่ 2 มีนาคม
                                                2568
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                          </>
                                        ) : (
                                          <>
                                            <div>
                                              1. ผู้ผ่านการคัดเลือก (ตัวจริง)
                                              สามารถยืนยันสิทธิ์และชำระค่าธรรมเนียมการศึกษาได้
                                              ตั้งแต่วันที่ 1 - 3 มีนาคม 2568
                                            </div>
                                          </>
                                        )}
                                      </Pane>
                                    ) : (
                                      ""
                                    )}
                                  </>
                                )}
                              </>
                            )}

                            {}
                          </Pane>
                        ) : (
                          <Pane>
                            {i.ROB_ID === "140" ? (
                              <>
                                <Badge
                                  color="green"
                                  padding={5}
                                  fontFamily=""
                                  fontSize={14}
                                  height="100%"
                                >
                                  <AiFillCheckCircle /> ผู้มีสิทธิ์เข้าศึกษา
                                  {i.Major1_faculty_name} หลักสูตร
                                  {i.Major1_LEVEL_OPEN_NAME} {i.Major1_MAJOR_ID} :
                                  {i.Major1_MAJOR_NAME}
                                </Badge>
                              </>
                            ) : (
                              <Badge
                                color="green"
                                padding={5}
                                fontFamily=""
                                fontSize={14}
                                height="100%"
                              >
                                <AiFillCheckCircle /> ผ่านการคัดเลือก{" "}
                                {i.Major1_MAJOR_ID === "9902" ? "(ตัวจริง)" : ""}
                                {i.QUOTA_NAME} {i.Major1_faculty_name} หลักสูตร
                                {i.Major1_LEVEL_OPEN_NAME} {i.Major1_MAJOR_ID} :
                                {i.Major1_MAJOR_NAME}
                              </Badge>
                            )}

                            {/* <Badge color="green" padding={5} fontFamily="" fontSize={14} height="100%">
                            <AiFillCheckCircle /> ผ่านการคัดเลือก {i.Major1_MAJOR_ID === "9902" ? "(ตัวจริง)" : ""}  
                            {i.QUOTA_NAME} {i.Major1_faculty_name} หลักสูตร
                            {i.Major1_LEVEL_OPEN_NAME} {i.Major1_MAJOR_ID} :{i.Major1_MAJOR_NAME}
                          </Badge> */}
                            {/* <Badge className="mt-2" color="yellow" padding={5} fontFamily="" fontSize={14} height="100%">
                            <Pane alignItems="flex-start" display="flex" flexDirection="column" gap={"10px"}>
                              <div>
                                {" "}
                                <FaClock />
                                ส่งผลการตรวจร่างกาย ณ อาคารคณะพยาบาลศาสตร์ มหาวิทยาลัยราชภัฏกำแพงเพชร (ตัวจริง)
                              </div>{" "}
                              <div> &nbsp;&nbsp;&nbsp; ตั้งแต่วันนี้ ถึงวันพฤหัสบดีที่ 29 กุมภาพันธ์ 2568 </div>
                            </Pane>
                          </Badge>{" "} */}
                            <div className="mt-2">
                              {/* <Text fontFamily="" fontSize="12px">
                              * สามารถดูรายละเอียดเพิ่มเติมได้ที่ประกาศ
                            </Text> */}
                            </div>
                            <Pane paddingTop={10} display="flex" flexDirection="column">
                              <b>*หมายเหตุ</b>
                              {i.REGISTER_ID === "6709902270" || i.REGISTER_ID === "6709902358" ? (
                                <>
                                  <div>
                                    1. ผู้ผ่านการคัดเลือก (ตัวจริง)
                                    สามารถยืนยันสิทธิ์และชำระค่าธรรมเนียมการศึกษาได้ ตั้งแต่วันที่
                                    18 - 20 มีนาคม 2568
                                  </div>
                                  {/* <div>2. ประกาศผลการคัดเลือก (ตัวสำรอง) วันที่ 12 มีนาคม 2568 </div> */}
                                </>
                              ) : (
                                <>
                                  <div>
                                    1. ผู้ผ่านการคัดเลือก (ตัวจริง)
                                    สามารถยืนยันสิทธิ์และชำระค่าธรรมเนียมการศึกษาได้ ตั้งแต่วันที่ 5
                                    - 10 มีนาคม 2568
                                  </div>
                                  <div>
                                    2. ประกาศผลการคัดเลือก (ตัวสำรอง) วันที่ 12 มีนาคม 2568{" "}
                                  </div>
                                </>
                              )}
                              {/* <b>*หมายเหตุ</b>
                            <div>
                              1. ผู้ผ่านการคัดเลือก (ตัวจริง) ส่งผลการตรวจร่างกายที่มหาวิทยาลัยราชภัฏกำแพงเพชร
                              <br />
                              ตั้งแต่วันนี้ถึงวันพฤหัสบดีที่ 29 กุมภาพันธ์ 2568
                            </div>
                            <div>2. ประกาศผลการคัดเลือก (ตัวสำรอง) วันที่ 12 มีนาคม 2568 </div> */}
                            </Pane>
                          </Pane>
                        )
                      ) : i.REGISTER_STATUS === "5" ? (
                        <Pane>
                          <Badge color="red" padding={5} fontFamily="" fontSize={14} height="100%">
                            <AiFillCloseCircle /> สละสิทธิ์
                            {i.QUOTA_NAME} {i.Major1_faculty_name} หลักสูตร
                            {i.Major1_LEVEL_OPEN_NAME} {i.Major1_MAJOR_ID} :{i.Major1_MAJOR_NAME}
                          </Badge>
                        </Pane>
                      ) : i.REGISTER_STATUS === "6" ? (
                        <Pane>
                          <Badge color="blue" padding={5} fontFamily="" fontSize={14} height="100%">
                            <AiFillCheckCircle /> ยืนยันสิทธิ์
                            {i.QUOTA_NAME} {i.ROB_NAME} {i.Major1_faculty_name} หลักสูตร
                            {i.Major1_LEVEL_OPEN_NAME} {i.Major1_MAJOR_ID} :{i.Major1_MAJOR_NAME}
                          </Badge>
                          {i.Major1_MAJOR_ID === "9903" ? (
                            <>
                              <Pane display="flex" flexDirection="column">
                                <Text fontWeight={600} color="green">
                                  *หมายเหตุ
                                </Text>
                                <Text>
                                  1. ผู้ที่ชำระเงินค่าธรรมเนียมการศึกษาเรียบร้อยแล้ว
                                  ต้องกรอกข้อมูลประวัติและอัปโหลดไฟล์เอกสาร ตั้งแต่วันที่ 8 – 12
                                  กรกฎาคม พ.ศ. 2568
                                </Text>
                              </Pane>
                            </>
                          ) : (
                            <>
                              {i.REGISTER_TYPE_ID === "2" || i.REGISTER_TYPE_ID === "3" ? (
                                <Pane display="flex" flexDirection="column">
                                  <Text fontWeight={600} color="green">
                                    *หมายเหตุ
                                  </Text>
                                  <Text>
                                    กรอกข้อมูลทะเบียนประวัติ และอัปโหลดเอกสารการรายงานตัว
                                    ตั้งแต่วันที่ 27 พฤษภาคม 2568 – วันศุกร์ที่ 7 มิถุนายน 2568
                                  </Text>
                                </Pane>
                              ) : (
                                <Pane display="flex" flexDirection="column">
                                  <Text fontWeight={600} color="green">
                                    *หมายเหตุ
                                  </Text>
                                  <Text>
                                    กรอกข้อมูลทะเบียนประวัติ และอัปโหลดเอกสารการรายงานตัว
                                    ตั้งแต่วันที่ 9 - 30 เมษายน 2568
                                  </Text>
                                </Pane>
                              )}
                            </>
                          )}
                        </Pane>
                      ) : i.REGISTER_STATUS === "7" ? (
                        <Pane>
                          <Badge
                            className="mt-2"
                            color="yellow"
                            padding={5}
                            fontFamily=""
                            fontSize={14}
                            height="100%"
                          >
                            <FaClock /> ตรวจสอบวุฒิ {i.QUOTA_NAME} {i.Major1_faculty_name} หลักสูตร
                            {i.Major1_LEVEL_OPEN_NAME} {i.Major1_MAJOR_ID} :{i.Major1_MAJOR_NAME}
                          </Badge>
                        </Pane>
                      ) : i.REGISTER_STATUS === "9" ? (
                        <Pane>
                          <Badge
                            fontFamily=""
                            className="mt-2"
                            color="#fb6f92"
                            backgroundColor={"#ffe5ec"}
                            padding={5}
                            fontSize={14}
                            height="100%"
                          >
                            <BiSolidUserBadge /> เอกสารประกอบข้อมูลรายงานตัว
                            {i.Major1_faculty_name} {i.Major1_MAJOR_ID} :{i.Major1_MAJOR_NAME}{" "}
                            ผ่านการตรวจสอบเรียบร้อยแล้ว
                          </Badge>
                        </Pane>
                      ) : i.REGISTER_STATUS === "91" ? (
                        <Pane>
                          <Badge
                            fontFamily=""
                            className="mt-2"
                            color="red"
                            padding={5}
                            fontSize={14}
                            height="100%"
                          >
                            <BiSolidUserBadge /> ลาออก
                            {i.Major1_faculty_name} {i.Major1_MAJOR_ID} :{i.Major1_MAJOR_NAME}
                          </Badge>
                        </Pane>
                      ) : i.REGISTER_STATUS === "41" ? (
                        <Pane
                          display="flex"
                          flexDirection="column"
                          gap="10px"
                          justifyContent="start"
                          alignItems="start"
                        >
                          <Badge
                            color="green"
                            padding={5}
                            fontFamily=""
                            fontSize={14}
                            height="100%"
                          >
                            <AiFillCheckCircle /> ผ่านการคัดเลือก{" "}
                            {i.Major1_MAJOR_ID === "9902" ? "(ตัวจริง)" : ""}
                            {i.QUOTA_NAME} {i.Major1_faculty_name} หลักสูตร
                            {i.Major1_LEVEL_OPEN_NAME} {i.Major1_MAJOR_ID} :{i.Major1_MAJOR_NAME}
                          </Badge>
                          <Badge
                            color="#5C85FF"
                            padding={5}
                            fontFamily=""
                            backgroundColor="#EBF0FF"
                            fontSize={14}
                            height="100%"
                          >
                            ผ่านการคัดเลือก {i.REGISTER_ORDER}
                          </Badge>

                          <Pane paddingTop={10} display="flex" flexDirection="column">
                            <b>*หมายเหตุ</b>
                            <div>
                              {" "}
                              1. ผู้ผ่านการคัดเลือก (ตัวจริง)
                              สามารถยืนยันสิทธิ์และชำระค่าธรรมเนียมการศึกษาได้ ตั้งแต่วันที่ 24 - 28
                              เมษายน 2568
                            </div>
                            {i.ROB_ID !== "134" && i.ROB_ID !== "135" && i.ROB_ID !== "136" ? (
                              <div>2. ประกาศผลการคัดเลือก (ตัวสำรอง) วันที่ 29 เมษายน 2568</div>
                            ) : (
                              ""
                            )}
                            {/* {i.ROB_ID !== "134" &&
                                    i.ROB_ID !== "135" &&
                                    i.ROB_ID !== "136" ? (
                                      <div>
                                        2. ประกาศผลการคัดเลือก (ตัวสำรอง) วันที่
                                        5 มกราคม 2568
                                      </div>
                                    ) : (
                                      ""
                                    )} */}
                          </Pane>

                          {/* <Badge color="yellow" padding={5} fontFamily="" fontSize={14} height="100%">
                      รอประกาศรายชื่อผู้ผ่านการคัดเลือกตัวจริง และตัวสำรอง
                        </Badge> */}
                          {/*                        
                        <Badge color="green" padding={5} fontFamily="" fontSize={14} height="100%">
                          <AiFillCheckCircle /> ผ่านการคัดเลือก {i.Major1_MAJOR_ID === "9902" ? "(ตัวจริง)" : ""}
                          {i.QUOTA_NAME} {i.Major1_faculty_name} หลักสูตร
                          {i.Major1_LEVEL_OPEN_NAME} {i.Major1_MAJOR_ID} :{i.Major1_MAJOR_NAME}
                        </Badge>
                        <Badge color="#5C85FF" padding={5} fontFamily="" backgroundColor="#EBF0FF" fontSize={14} height="100%">
                          ผ่านการคัดเลือก {i.REGISTER_ORDER}
                        </Badge>
                       
                        */}
                        </Pane>
                      ) : i.REGISTER_STATUS === "8" ? (
                        <Pane>
                          <Badge
                            fontFamily=""
                            className="mt-2"
                            color="yellow"
                            padding={5}
                            fontSize={14}
                            height="100%"
                          >
                            <AiFillClockCircle /> อยู่ระหว่างการกรอกข้อมูลรายงานตัว
                            และตรวจสอบเอกสารรายงานตัว
                          </Badge>
                        </Pane>
                      ) : i.REGISTER_STATUS === "10" ? (
                        <Pane>
                          <Badge
                            fontFamily=""
                            className="mt-2"
                            color="blue"
                            padding={5}
                            fontSize={14}
                            height="100%"
                          >
                            ย้ายสาขา
                          </Badge>
                        </Pane>
                      ) : i.REGISTER_STATUS === "11" ? (
                        <Pane>
                          <Badge
                            fontFamily=""
                            className="mt-2"
                            color="red"
                            padding={5}
                            fontSize={14}
                            height="100%"
                          >
                            ไม่ผ่านการคัดเลือก {i.Major1_faculty_name} {i.Major1_MAJOR_ID} :
                            {i.Major1_MAJOR_NAME}
                          </Badge>
                          {/* <div>*หมายเหตุ</div> */}
                          {/* <div>เปิดรับสมัครภาคปกติ รอบ 3 วันที่ 6 มีนาคม - 10 พฤษภาคม 2568</div> */}
                        </Pane>
                      ) : i.REGISTER_STATUS === "12" ? (
                        <Pane>
                          <Badge
                            fontFamily=""
                            className="mt-2"
                            color="red"
                            padding={5}
                            fontSize={14}
                            height="100%"
                          >
                            ไม่ผ่านเกณฑ์ {i.Major1_faculty_name} {i.Major1_MAJOR_ID} :
                            {i.Major1_MAJOR_NAME}
                            <br /> {"กรุณาติดต่อ 055-706547"}
                          </Badge>
                        </Pane>
                      ) : (
                        <></>
                      )}
                      {i.REGISTER_STATUS !== "4" &&
                      i.REGISTER_STATUS !== "3" &&
                      // i.REGISTER_STATUS !== "0" &&
                      i.REGISTER_STATUS !== "5" &&
                      i.REGISTER_STATUS !== "7" &&
                      i.REGISTER_STATUS !== "9" &&
                      i.REGISTER_STATUS !== "10" &&
                      i.REGISTER_STATUS !== "11" &&
                      i.REGISTER_STATUS !== "12" &&
                      i.REGISTER_STATUS !== "91" &&
                      i.REGISTER_STATUS !== "41" &&
                      i.REGISTER_STATUS !== "6" ? (
                        <Pane
                          className="container-fluid"
                          style={{ minWidth: "700px" }}
                          backgroundColor=""
                          marginTop={10}
                        >
                          {i.Major1_MAJOR_ID === "99s02" ? (
                            <></>
                          ) : (
                            <>
                              <MDBDataTableV5
                                theadColor="deep-purple"
                                theadTextWhite
                                responsive
                                searching={false}
                                displayEntries={false}
                                bordered
                                borderless={false}
                                data={
                                  i.Major1_MAJOR_ID === "9902"
                                    ? datatatatatnu(i.REGISTER_TYPE_ID, i.REGISTER_ID, i.ROB_ID)
                                    : datatatatat(
                                        i.REGISTER_TYPE_ID,
                                        i.REGISTER_ID,
                                        i.ROB_ID,
                                        i.Major1_MAJOR_ID,
                                        i.REGISTER_STATUS
                                      )
                                }
                              />
                            </>
                          )}
                        </Pane>
                      ) : i.REGISTER_STATUS === "1" &&
                        (i.ROB_ID === "134" ||
                          i.ROB_ID === "135" ||
                          i.ROB_ID === "136" ||
                          i.ROB_ID === "140" ||
                          i.ROB_ID === "139") ? (
                        <>
                          <Pane
                            className="container-fluid"
                            style={{ minWidth: "700px" }}
                            backgroundColor=""
                            marginTop={10}
                          >
                            <MDBDataTableV5
                              theadColor="deep-purple"
                              theadTextWhite
                              responsiveMd
                              searching={false}
                              displayEntries={false}
                              bordered
                              borderless={false}
                              data={
                                i.Major1_MAJOR_ID === "9902"
                                  ? datatatatatnu(i.REGISTER_TYPE_ID, i.REGISTER_ID, i.ROB_ID)
                                  : datatatatat(i.REGISTER_TYPE_ID, i.REGISTER_ID)
                              }
                            />
                          </Pane>
                        </>
                      ) : (
                        <></>
                      )}
                    </Pane>
                  ),
                manage:
                  i.ROB_ID === "148" ? (
                    <>
                      {i.REGISTER_STATUS === "0" ? (
                        <>
                          <Button
                            // hidden={""}
                            appearance="minimal"
                            color="white"
                            disabled={i.ROB_CLOSE_CHK === "เปิดชำระ" ? false : true}
                            backgroundColor="#38b000"
                            className="btnsucc"
                            onClick={() => {
                              OpenPayRegister(
                                i.ROB_YEAR,
                                i.FULLNAME,
                                i.REGISTER_ID,
                                i.ROB_CLOSE,
                                i.ROB_MONEY
                              );
                            }}
                            iconBefore={<FaMoneyBills />}
                          >
                            ชำระเงินค่าสมัคร
                          </Button>
                        </>
                      ) : i.REGISTER_STATUS === "4" ? (
                        <>
                          {/* <Text hidden={CheckPayPresentOpen(i.QUOTA_DATE_CLOSE_MONEY, i.QUOTA_DATE_OPEN_MONEY)} color="red">
                            *เกินกำหนดการชำระเงิน กรุณาติดต่อ 055 - 706547
                          </Text> */}
                          <Button
                            className={i.ROB_ID === "148" ? "" : "d-none"}
                            onClick={() => {
                              Pay1Kru(
                                i.REGISTER_STATUS,
                                i.ROB_ID,
                                i.REGISTER_ID,
                                i.ROB_YEAR,
                                i.Major1_LEVEL_OPEN_NAME,
                                i.REGISTER_TYPE_ID,
                                i.Major1_MAJOR_ID
                              );
                            }}
                            iconBefore={<FaMoneyBills />}
                            appearance="primary"
                            disabled={
                              !CheckPayPresent(i.QUOTA_DATE_CLOSE_MONEY, i.QUOTA_DATE_OPEN_MONEY)
                            }
                            intent="success"
                          >
                            ยืนยันสิทธิ์และชำระเงิน
                          </Button>
                        </>
                      ) : (
                        <></>
                      )}
                      <Button
                        backgroundColor="violet"
                        color="white"
                        className="btn-0"
                        onClick={() => {
                          GetNews(i.REGISTER_TYPE_ID, i.Major1_MAJOR_ID, i.ROB_ID).then((res) => {
                            window.open(
                              i.Major1_MAJOR_ID === "1202" ||
                                i.Major1_MAJOR_ID === "1204" ||
                                i.Major1_MAJOR_ID === "1206" ||
                                i.Major1_MAJOR_ID === "1207" ||
                                i.Major1_MAJOR_ID === "1208"
                                ? admission + "/public/news/1713923795.pdf"
                                : i.REGISTER_ID === "6709902270" || i.REGISTER_ID === "6709902358"
                                ? admission + "/public/news/1710744333.pdf"
                                : i.ROB_ID === "147" &&
                                  (i.Major1_faculty_name === "คณะครุศาสตร์" ||
                                    i.Major1_MAJOR_ID === "1110")
                                ? admission + "/public/news/1709689861.pdf"
                                : i.ROB_ID === "147"
                                ? admission + "/public/news/1709689918.pdf"
                                : i.REGISTER_ID === "6709902391" || i.REGISTER_ID === "6709902388"
                                ? admission + "/public/news/1708569688.pdf"
                                : i.ROB_ID === "139" &&
                                  i.Major1_faculty_name !== "คณะครุศาสตร์" &&
                                  i.Major1_MAJOR_ID !== "1110"
                                ? admission + "/public/news/1708562221.pdf"
                                : res
                            );
                          });
                        }}
                      >
                        คลิกเพื่อดูประกาศ
                      </Button>
                    </>
                  ) : (
                    <Pane display="flex" flexDirection="column" gap="10px">
                      {i.REGISTER_STATUS === "0" ? (
                        <Pane>
                          {i.ROB_ID === "130" ||
                          i.ROB_ID === "134" ||
                          i.ROB_ID === "135" ||
                          i.ROB_ID === "136" ? (
                            <Text color="red">*เกินกำหนดการชำระเงิน </Text>
                          ) : // ) : i.ROB_CLOSE_CHK === "เปิดชำระ" && parseInt(i.ROB_ID) < 137 && i.ROB_ID !== "131" ? (
                          //   <Text color="red">*เกินกำหนดการชำระเงิน</Text>
                          i.ROB_CLOSE_CHK === "ปิดชำระ" ? (
                            <>
                              <Text color="red">*เกินกำหนดการชำระเงิน </Text>
                            </>
                          ) : i.ROB_CLOSE_CHK === "เปิดชำระ" &&
                            i.Major1_MAJOR_ID !== "1206" &&
                            i.Major1_MAJOR_ID !== "1207" &&
                            i.Major1_MAJOR_ID !== "1208" &&
                            i.Major1_MAJOR_ID !== "1202" &&
                            i.Major1_MAJOR_ID !== "1204" ? (
                            ""
                          ) : (
                            <Text color="red">*เกินกำหนดการชำระเงิน</Text>
                          )}
                          {/* {new Date("4/10/2025").toLocaleDateString() > new Date().toLocaleDateString() ? "ใช่":"ไม่ใช่"}
{new Date("3/10/2025").toLocaleDateString()}
{new Date().toLocaleDateString()} */}
                          {i.ROB_ID === "147" ? (
                            <Button
                              // hidden={""}
                              appearance="minimal"
                              color="white"
                              disabled={
                                i.ROB_CLOSE_CHK === "เปิดชำระ" &&
                                i.Major1_MAJOR_ID !== "1206" &&
                                i.Major1_MAJOR_ID !== "1207" &&
                                i.Major1_MAJOR_ID !== "1208" &&
                                i.Major1_MAJOR_ID !== "1202" &&
                                i.Major1_MAJOR_ID !== "1204"
                                  ? false
                                  : true
                              }
                              backgroundColor="#38b000"
                              className="btnsucc"
                              onClick={() => {
                                OpenPayRegister(
                                  i.ROB_YEAR,
                                  i.FULLNAME,
                                  i.REGISTER_ID,
                                  i.ROB_CLOSE,
                                  i.ROB_MONEY
                                );
                              }}
                              iconBefore={<FaMoneyBills />}
                            >
                              ชำระเงินค่าสมัคร
                            </Button>
                          ) : (
                            <Button
                              // hidden={""}
                              appearance="minimal"
                              color="white"
                              disabled={
                                // i.ROB_ID === "130" || i.ROB_ID === "134" || i.ROB_ID === "135" || i.ROB_ID === "136"
                                // ? true
                                i.ROB_CLOSE_CHK === "เปิดชำระ"
                                  ? // && parseInt(i.ROB_ID) < 137 && i.ROB_ID !== "131"
                                    false
                                  : true
                              }
                              backgroundColor="#38b000"
                              className="btnsucc"
                              onClick={() => {
                                OpenPayRegister(
                                  i.ROB_YEAR,
                                  i.FULLNAME,
                                  i.REGISTER_ID,
                                  i.ROB_CLOSE,
                                  i.ROB_MONEY
                                );
                              }}
                              iconBefore={<FaMoneyBills />}
                            >
                              ชำระเงินค่าสมัคร
                            </Button>
                          )}
                        </Pane>
                      ) : i.REGISTER_STATUS === "1" ? (
                        <Pane>
                          <Pane>
                            {i.Major1_MAJOR_ID === "1304" ? (
                              <>
                                <Button
                                  appearance="view"
                                  backgroundColor="#EBF0FF"
                                  color="#5C85FF"
                                  disabled={true}
                                  opacity={0.3}
                                  onClick={() => {
                                    {
                                      i.Major1_MAJOR_ID === "9902"
                                        ? openAdmissionPrint(admission + "/dashboard_printregistrar2018_nurse?code_test=" +
                                              i.REGISTER_ID
                                          )
                                        : openAdmissionPrint(admission + "/dashboard_printregistrar2022?code_test=" +
                                              i.REGISTER_ID
                                            //6411207001คือรหัสประจำตัวผู้สมัคร
                                          );
                                    }
                                  }}
                                  //ปิดชำระรอพี่อ้อตรวจเอกสาร
                                  iconBefore={<FaNewspaper />}
                                >
                                  พิมพ์ใบสมัคร
                                </Button>
                              </>
                            ) : (
                              <>
                                {i.ROB_ID === "134" || i.ROB_ID === "135" || i.ROB_ID === "136" ? (
                                  ""
                                ) : i.ROB_ID === "131" ? (
                                  <>
                                    <Button
                                      appearance="view"
                                      backgroundColor="#EBF0FF"
                                      color="#5C85FF"
                                      disabled={true}
                                      opacity={0.3}
                                      onClick={() => {
                                        openAdmissionPrint(admission + "/dashboard_printregistrar2022?code_test=" +
                                            i.REGISTER_ID
                                          //6411207001คือรหัสประจำตัวผู้สมัคร
                                        );
                                      }}
                                      //ปิดชำระรอพี่อ้อตรวจเอกสาร
                                      iconBefore={<FaNewspaper />}
                                    >
                                      พิมพ์ใบสมัคร
                                    </Button>
                                  </>
                                ) : (
                                  <>
                                    {i.Major1_MAJOR_ID === "9903" ? (
                                      <>
                                        <Button
                                          appearance="view"
                                          backgroundColor="#EBF0FF"
                                          color="#5C85FF"
                                          onClick={() => {
                                            {
                                              i.Major1_MAJOR_ID === "9902"
                                                ? openAdmissionPrint(admission + "/dashboard_printregistrar2018_nurse?code_test=" +
                                                      i.REGISTER_ID
                                                  )
                                                : openAdmissionPrint(admission + "/dashboard_printregistrar2022?code_test=" +
                                                      i.REGISTER_ID
                                                    //6411207001คือรหัสประจำตัวผู้สมัคร
                                                  );
                                            }
                                          }}
                                          //ปิดชำระรอพี่อ้อตรวจเอกสาร
                                          iconBefore={<FaNewspaper />}
                                        >
                                          พิมพ์ใบสมัคร
                                        </Button>
                                      </>
                                    ) : (
                                      <>
                                        <Button
                                          appearance="view"
                                          backgroundColor="#EBF0FF"
                                          color="#5C85FF"
                                          disabled={
                                            i.REGISTER_TYPE_ID === "4" || i.REGISTER_TYPE_ID === "7"
                                              ? false
                                              : true
                                          }
                                          opacity={
                                            i.REGISTER_TYPE_ID === "4" || i.REGISTER_TYPE_ID === "7"
                                              ? 1
                                              : 0.3
                                          }
                                          onClick={() => {
                                            {
                                              i.Major1_MAJOR_ID === "9902"
                                                ? openAdmissionPrint(admission + "/dashboard_printregistrar2018_nurse?code_test=" +
                                                      i.REGISTER_ID
                                                  )
                                                : openAdmissionPrint(admission + "/dashboard_printregistrar2022?code_test=" +
                                                      i.REGISTER_ID
                                                    //6411207001คือรหัสประจำตัวผู้สมัคร
                                                  );
                                            }
                                          }}
                                          //ปิดชำระรอพี่อ้อตรวจเอกสาร
                                          iconBefore={<FaNewspaper />}
                                        >
                                          พิมพ์ใบสมัคร
                                        </Button>
                                      </>
                                    )}
                                  </>
                                )}
                                {/* {i.ROB_ID === "140" ? <><Badge>
                                *หากข้อมูลน้ำหนัก,ส่วนสูง 
                                </Badge></> : ""} */}
                              </>
                            )}
                          </Pane>
                        </Pane>
                      ) : i.REGISTER_STATUS === "2" ? (
                        <Pane>
                          {/* <Button
                          appearance="view"
                          backgroundColor="#EBF0FF"
                          color="#5C85FF"
                          disabled={false}
                          onClick={() => {
                            {
                              i.Major1_MAJOR_ID === "9902"
                                ? openAdmissionPrint(admission + "/dashboard_printregistrar2018_nurse?code_test=" +
                                      i.REGISTER_ID,
                                    "_blank" //6411207001คือรหัสประจำตัวผู้สมัคร
                                  )
                                : openAdmissionPrint(admission + "/dashboard_printregistrar2022?code_test=" +
                                      i.REGISTER_ID,
                                    "_blank" //6411207001คือรหัสประจำตัวผู้สมัคร
                                  );
                            }
                          }}
                          //ปิดชำระรอพี่อ้อตรวจเอกสาร
                          iconBefore={<FaNewspaper />}
                        >
                          พิมพ์ใบสมัคร
                        </Button> */}
                        </Pane>
                      ) : i.REGISTER_STATUS === "4" ? (
                        <>
                          {/* <Text hidden={CheckPayPresentOpen(i.QUOTA_DATE_CLOSE_MONEY, i.QUOTA_DATE_OPEN_MONEY)} color="red">
                            *เกินกำหนดการชำระเงิน กรุณาติดต่อ 055 - 706547
                          </Text> */}

                          <Button
                            onClick={() => {
                              Pay1Kru(
                                i.REGISTER_STATUS,
                                i.ROB_ID,
                                i.REGISTER_ID,
                                i.ROB_YEAR,
                                i.Major1_LEVEL_OPEN_NAME,
                                i.REGISTER_TYPE_ID,
                                i.Major1_MAJOR_ID
                              );
                            }}
                            iconBefore={<FaMoneyBills />}
                            appearance="primary"
                            hidden={
                              !CheckPayPresent(i.QUOTA_DATE_CLOSE_MONEY, i.QUOTA_DATE_OPEN_MONEY)
                            }
                            disabled={
                              !CheckPayPresent(i.QUOTA_DATE_CLOSE_MONEY, i.QUOTA_DATE_OPEN_MONEY)
                            }
                            intent="success"
                          >
                            ยืนยันสิทธิ์และชำระเงิน
                          </Button>
                          {i.Major1_MAJOR_ID !== "9902" ? (
                            <></>
                          ) : (
                            <>
                              {/* <a
                              ref={reffile}
                              href={nuFile}
                              download={"แบบฟอร์มรายงานผลการตรวจร่างกาย.pdf"}
                              className="d-none"
                            ></a>
                            <Button
                              onClick={() => {
                                reffile.current.click();
                              }}
                              iconBefore={<DownloadIcon />}
                              appearance="primary"
                              intent="primary"
                            >
                              แบบฟอร์มรายงานผลการตรวจร่างกาย
                            </Button> */}
                            </>
                          )}
                        </>
                      ) : i.REGISTER_STATUS === "6" || i.REGISTER_STATUS === "5" ? (
                        <Pane>
                          {/* {i.REGISTER_TYPE_ID === "6" && i.Major1_MAJOR_ID === "9903" ? ( */}
                          <>
                            {i.REGISTER_STATUS_BILL_ROBFULL_BOOK === "" ||
                            i.REGISTER_STATUS_BILL_ROBFULL_BOOK === null ||
                            i.REGISTER_STATUS_BILL_ROBFULL_BOOK === undefined ? (
                              i.REGISTER_STATUS_BILL_ROB1_BOOK === "" ||
                              i.REGISTER_STATUS_BILL_ROB1_BOOK === null ||
                              i.REGISTER_STATUS_BILL_ROB1_BOOK === undefined ? (
                                <></>
                              ) : (
                                <Pane display="flex" flexDirection="column" gap={10}>
                                  {/* { "https://e-finance.kpru.ac.th/printbill_admissionreportdownload?BOOK_YEAR=" +
                                          i.ROB_YEAR +
                                          "&BOOK_NO=" +
                                          i.REGISTER_STATUS_BILL_ROB2_BOOK.split(
                                            "/"
                                          )[1] +
                                          "&ID_NO=" +
                                          i.REGISTER_ID +
                                          "&NO=" +
                                          i.REGISTER_STATUS_BILL_ROB2_NO +
                                          "&typeuser=2&countbill=" +
                                          i.REGISTER_STATUS_BILL_ROB2_COUNT} */}
                                  <Button
                                    appearance="b"
                                    iconBefore={<FaReceipt />}
                                    backgroundColor="#0F5156"
                                    color="#D3F5F7"
                                    onClick={() => {
                                      // console.log(
                                      window.open(
                                        "https://e-finance.kpru.ac.th/printbill_admissionreportdownload?BOOK_YEAR=" +
                                          i.ROB_YEAR +
                                          "&BOOK_NO=" +
                                          i.REGISTER_STATUS_BILL_ROB1_BOOK.split("/")[1] +
                                          "&ID_NO=" +
                                          i.REGISTER_ID +
                                          "&NO=" +
                                          i.REGISTER_STATUS_BILL_ROB1_NO +
                                          "&typeuser=2&countbill=" +
                                          i.REGISTER_STATUS_BILL_ROB1_COUNT
                                      );
                                    }}
                                  >
                                    พิมพ์ใบเสร็จงวดที่ 1
                                  </Button>
                                  {i.REGISTER_STATUS_BILL_ROB2_BOOK === "" ||
                                  i.REGISTER_STATUS_BILL_ROB2_BOOK === null ||
                                  i.REGISTER_STATUS_BILL_ROB2_BOOK === undefined ? (
                                    <Button
                                      appearance="view"
                                      backgroundColor="#DCF2EA"
                                      color="#429777"
                                      fontWeight={700}
                                      iconBefore={<MdOutlinePayments />}
                                      onClick={() => {
                                        Pay2nd(
                                          i.REGISTER_STATUS,
                                          i.ROB_ID,
                                          i.REGISTER_ID,
                                          i.ROB_YEAR
                                        );
                                      }}
                                      // hidden={i.Major1_MAJOR_ID === "9902" ? true : false}
                                      // hidden={bbbbbb}
                                      hidden={true}
                                      // hidden={CheckDAte(i.QUOTA_DATE_CLOSE_MONEY, i.ROB_ID)}
                                    >
                                      ชำระเงินงวดที่ 2
                                    </Button>
                                  ) : (
                                    <Button
                                      appearance="b"
                                      iconBefore={<FaReceipt />}
                                      backgroundColor="#0F5156"
                                      color="#D3F5F7"
                                      onClick={() => {
                                        window.open(
                                          "https://e-finance.kpru.ac.th/printbill_admissionreportdownload?BOOK_YEAR=" +
                                            i.ROB_YEAR +
                                            "&BOOK_NO=" +
                                            i.REGISTER_STATUS_BILL_ROB2_BOOK.split("/")[1] +
                                            "&ID_NO=" +
                                            i.REGISTER_ID +
                                            "&NO=" +
                                            i.REGISTER_STATUS_BILL_ROB2_NO +
                                            "&typeuser=2&countbill=" +
                                            i.REGISTER_STATUS_BILL_ROB2_COUNT
                                        );
                                      }}
                                    >
                                      พิมพ์ใบเสร็จงวดที่ 2
                                    </Button>
                                  )}
                                  {i.REGISTER_ID === "6701110014" && (
                                    <>
                                      <Button
                                        appearance="b"
                                        iconBefore={<FaReceipt />}
                                        backgroundColor="#0F5156"
                                        color="#D3F5F7"
                                        onClick={() => {
                                          window.open(
                                            "https://e-finance.kpru.ac.th/printbill_admissionreportdownload?BOOK_YEAR=" +
                                              i.REGISTER_STATUS_BILL_ROB2_BOOK.split("/")[0] +
                                              "&BOOK_NO=" +
                                              i.REGISTER_STATUS_BILL_ROB2_BOOK.split("/")[1] +
                                              "&ID_NO=" +
                                              i.REGISTER_ID +
                                              "&NO=" +
                                              i.REGISTER_STATUS_BILL_ROB2_NO +
                                              "&typeuser=2&countbill=" +
                                              i.REGISTER_STATUS_BILL_ROB2_COUNT
                                          );
                                        }}
                                      >
                                        พิมพ์ใบเสร็จงวดที่ 2
                                      </Button>
                                    </>
                                  )}
                                </Pane>
                              )
                            ) : (
                              <>
                                <Button
                                  appearance="b"
                                  iconBefore={<FaReceipt />}
                                  backgroundColor="#0F5156"
                                  color="#D3F5F7"
                                  onClick={() => {
                                    window.open(
                                      "https://e-finance.kpru.ac.th/printbill_admissionreportdownload?BOOK_YEAR=" +
                                        i.ROB_YEAR +
                                        "&BOOK_NO=" +
                                        i.REGISTER_STATUS_BILL_ROBFULL_BOOK.split("/")[1] +
                                        "&ID_NO=" +
                                        i.REGISTER_ID +
                                        "&NO=" +
                                        i.REGISTER_STATUS_BILL_ROBFULL_NO +
                                        "&typeuser=2&countbill=" +
                                        i.REGISTER_STATUS_BILL_ROBFULL_COUNT
                                    );
                                  }}
                                >
                                  พิมพ์ใบเสร็จ
                                </Button>
                              </>
                            )}
                          </>
                          <Button
                            // color="white"
                            // backgroundColor="green"
                            className="btn  btn-outline-success"
                            marginTop={10}
                            hidden={i.DIFF_URL === "ZERO" ? true : false}
                            onClick={() => {
                              window.open(i.DIFF_URL);
                            }}
                          >
                            พิมพ์ใบเสร็จการชำระเงินค่าส่วนต่าง
                          </Button>
                          <br />
                          {/* <Button
                            marginTop={10}
                            appearance="primary"
                            intent="success"
                            width="100%"
                            // disabled={i.Major1_MAJOR_ID === "9901" ? false : CheckDatePresent()}
                            onClick={() => {
                              window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Checkpresent`;
                            }}
                            iconBefore={<DocumentIcon />}
                          >
                            กรอกข้อมูลรายงานตัว
                          </Button> */}
                          {/* )} */}
                        </Pane>
                      ) : i.REGISTER_STATUS === "9" ? (
                        <Pane display="flex" gap="10px" flexDirection="column">
                          {i.ROB_ID === "141" ? (
                            <>
                              {i.REGISTER_STATUS_BILL_ROBFULL_BOOK === "" ||
                              i.REGISTER_STATUS_BILL_ROBFULL_BOOK === null ||
                              i.REGISTER_STATUS_BILL_ROBFULL_BOOK === undefined ? (
                                i.REGISTER_STATUS_BILL_ROB1_BOOK === "" ||
                                i.REGISTER_STATUS_BILL_ROB1_BOOK === null ||
                                i.REGISTER_STATUS_BILL_ROB1_BOOK === undefined ? (
                                  <></>
                                ) : (
                                  <Pane display="flex" flexDirection="column" gap={10}>
                                    <Button
                                      appearance="b"
                                      iconBefore={<FaReceipt />}
                                      backgroundColor="#0F5156"
                                      color="#D3F5F7"
                                      onClick={() => {
                                        window.open(
                                          "https://e-finance.kpru.ac.th/printbill_admissionreportdownload?BOOK_YEAR=" +
                                            i.ROB_YEAR +
                                            "&BOOK_NO=" +
                                            i.REGISTER_STATUS_BILL_ROB1_BOOK.split("/")[1] +
                                            "&ID_NO=" +
                                            i.REGISTER_ID +
                                            "&NO=" +
                                            i.REGISTER_STATUS_BILL_ROB1_NO +
                                            "&typeuser=2&countbill=" +
                                            i.REGISTER_STATUS_BILL_ROB1_COUNT
                                        );
                                      }}
                                    >
                                      พิมพ์ใบเสร็จงวดที่ 1
                                    </Button>
                                    {i.REGISTER_STATUS_BILL_ROB2_BOOK === "" ||
                                    i.REGISTER_STATUS_BILL_ROB2_BOOK === null ||
                                    i.REGISTER_STATUS_BILL_ROB2_BOOK === undefined ? (
                                      <Button
                                        appearance="view"
                                        backgroundColor="#DCF2EA"
                                        // disabled={isInRange ? false : true}
                                        // disabled

                                        // opacity={0.3}
                                        color="#429777"
                                        fontWeight={700}
                                        iconBefore={<MdOutlinePayments />}
                                        onClick={() => {
                                          Pay2nd(
                                            i.REGISTER_STATUS,
                                            i.ROB_ID,
                                            i.REGISTER_ID,
                                            i.ROB_YEAR
                                          );
                                        }}
                                        // hidden
                                      >
                                        ชำระเงินงวดที่ 2
                                      </Button>
                                    ) : (
                                      <Button
                                        appearance="b"
                                        iconBefore={<FaReceipt />}
                                        disabled
                                        backgroundColor="#0F5156"
                                        color="#D3F5F7"
                                        onClick={() => {
                                          window.open(
                                            "https://e-finance.kpru.ac.th/printbill_admissionreportdownload?BOOK_YEAR=" +
                                              i.ROB_YEAR +
                                              "&BOOK_NO=" +
                                              i.REGISTER_STATUS_BILL_ROB2_BOOK.split("/")[1] +
                                              "&ID_NO=" +
                                              i.REGISTER_ID +
                                              "&NO=" +
                                              i.REGISTER_STATUS_BILL_ROB2_NO +
                                              "&typeuser=2&countbill=" +
                                              i.REGISTER_STATUS_BILL_ROB2_COUNT
                                          );
                                        }}
                                      >
                                        พิมพ์ใบเสร็จงวดที่ 2
                                      </Button>
                                    )}
                                  </Pane>
                                )
                              ) : (
                                <>
                                  <Button
                                    appearance="b"
                                    iconBefore={<FaReceipt />}
                                    backgroundColor="#0F5156"
                                    color="#D3F5F7"
                                    onClick={() => {
                                      window.open(
                                        "https://e-finance.kpru.ac.th/printbill_admissionreportdownload?BOOK_YEAR=" +
                                          i.ROB_YEAR +
                                          "&BOOK_NO=" +
                                          i.REGISTER_STATUS_BILL_ROBFULL_BOOK.split("/")[1] +
                                          "&ID_NO=" +
                                          i.REGISTER_ID +
                                          "&NO=" +
                                          i.REGISTER_STATUS_BILL_ROBFULL_NO +
                                          "&typeuser=2&countbill=" +
                                          i.REGISTER_STATUS_BILL_ROBFULL_COUNT
                                      );
                                    }}
                                  >
                                    พิมพ์ใบเสร็จ
                                  </Button>
                                </>
                              )}
                            </>
                          ) : (
                            <></>
                            // <Button
                            //   appearance="primary"
                            //   intent="success"
                            //   width="100%"
                            //   // disabled
                            //   onClick={() => {
                            //     window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Checkpresent`;
                            //   }}
                            //   iconBefore={<DocumentIcon />}
                            // >
                            //   กรอกข้อมูลรายงานตัว
                            // </Button>
                            // <></>
                          )}
                          {i.Major1_MAJOR_ID === "9903" ? (
                            <></>
                          ) : (
                            <>
                              {/* <Button
                                appearance="primary"
                                intent="success"
                                width="100%"
                                // disabled
                                onClick={() => {
                                  window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Checkpresent`;
                                }}
                                iconBefore={<DocumentIcon />}
                              >
                                กรอกข้อมูลรายงานตัว
                              </Button> */}
                            </>
                          )}

                          <Button
                            appearance="primary"
                            intent="danger"
                            width="100%"
                            onClick={(e) => {
                              window.location.href = `${process.env.REACT_APP_BASENAME || ""}/waiver`;
                            }}
                            // disabled
                            iconBefore={<FaUserSlash />}
                          >
                            แบบฟอร์มขอสละสิทธิ์เข้าศึกษา
                          </Button>
                        </Pane>
                      ) : (
                        <></>
                      )}
                      {i.REGISTER_STATUS !== "0" &&
                      i.REGISTER_STATUS !== "1" &&
                      i.REGISTER_STATUS !== "2" &&
                      i.REGISTER_STATUS !== "3" &&
                      i.REGISTER_STATUS !== "4" ? (
                        <>
                          {/* <Button
                          appearance="b"
                          iconBefore={<FaReceipt />}
                          backgroundColor="#0F5156"
                          color="#D3F5F7"
                        >
                          ดูใบเสร็จชำระค่าธรรมเนียม
                        </Button> */}
                        </>
                      ) : (
                        <></>
                      )}
                      {/* {i.ROB_ID === "137" || i.ROB_ID === "138" || (i.ROB_ID === "144" && i.Major1_MAJOR_ID === "1304" ) || } */}
                      {i.REGISTER_STATUS === "6" ? (
                        <>
                          {" "}
                          <Button
                            onClick={(e) => {
                              window.location.pathname = `${process.env.REACT_APP_BASENAME || ""}/waiver`;
                            }}
                            appearance="primary"
                            intent="danger"
                          >
                            แบบฟอร์มขอสละสิทธิ์เข้าศึกษา
                          </Button>
                        </>
                      ) : null}
                      <Button
                        backgroundColor="violet"
                        color="white"
                        className="btn-0"
                        onClick={() => {
                          GetNews(i.REGISTER_TYPE_ID, i.Major1_MAJOR_ID, i.ROB_ID).then((res) => {
                            window.open(
                              i.Major1_MAJOR_ID === "1202" ||
                                i.Major1_MAJOR_ID === "1204" ||
                                i.Major1_MAJOR_ID === "1206" ||
                                i.Major1_MAJOR_ID === "1207" ||
                                i.Major1_MAJOR_ID === "1208"
                                ? admission + "/public/news/1713923795.pdf"
                                : i.REGISTER_ID === "6709902270" || i.REGISTER_ID === "6709902358"
                                ? admission + "/public/news/1710744333.pdf"
                                : i.ROB_ID === "147" &&
                                  (i.Major1_faculty_name === "คณะครุศาสตร์" ||
                                    i.Major1_MAJOR_ID === "1110")
                                ? admission + "/public/news/1709689861.pdf"
                                : i.ROB_ID === "147"
                                ? admission + "/public/news/1709689918.pdf"
                                : i.REGISTER_ID === "6709902391" || i.REGISTER_ID === "6709902388"
                                ? admission + "/public/news/1708569688.pdf"
                                : i.ROB_ID === "139" &&
                                  i.Major1_faculty_name !== "คณะครุศาสตร์" &&
                                  i.Major1_MAJOR_ID !== "1110"
                                ? admission + "/public/news/1708562221.pdf"
                                : i.ROB_ID === "131" &&
                                  (i.REGISTER_STATUS === "4" || i.REGISTER_STATUS === "6")
                                ? admission + "/public/news/1714697358.pdf"
                                : i.ROB_ID === "131"
                                ? admission + "/public/news/1713427899.pdf"
                                : res
                            );
                          });
                        }}
                      >
                        คลิกเพื่อดูประกาศ
                      </Button>
                    </Pane>
                  ),
              })),
            ],
          });
        }
      }
      setFirstFetch(true);
    } catch (error) {}
  };
  useEffect(() => {
    if (FirstFetch === false) {
      StartComponent();
    }
  }, []);
  useEffect(() => {}, [FirstFetch]);
  const [SelectFile, setSelectFile] = useState(null);
  const onFileChange = (e) => {
    setSelectFile(e[0]);
  };

  const UplodFile = () => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Basic ${localStorage.getItem("token")}`,
      "content-type": "multipart/form-data",
    };
    var reader = new FileReader();
    reader.readAsDataURL(SelectFile);
    reader.onload = function () {
      let formData = new FormData();
      console.log(reader.result);
      formData.append("File", reader.result);
      axios
        .post(
          mua + "/admissionnew2022/uploadfile/" +
            localStorage.getItem("citizent"),
          formData,
          { headers }
        )
        .then((res) => {
          if (res.data !== 0) {
            Swal.fire({
              icon: "success",
              title: "แก้ไขไฟล์เสร็จสิ้น",
              timer: 1500,
              timerProgressBar: true,
              showConfirmButton: false,
            }).then((res) => {
              window.location.reload();
            });
          }
        });
    };
  };

  const Pay2nd = (status, robid, regisid, robyear) => {
    axios
      .get(
        mua + "/admission/getEligibleInterviewReports_new/" +
          localStorage.getItem("citizent") +
          "/" +
          status +
          "/" +
          robid +
          "/" +
          regisid
      )
      .then((res) => {
        localStorage.setItem("IDNOO", regisid);
        localStorage.setItem("stopdate", res.data[0].SALARY_DATE_CLOSE);
        localStorage.setItem("TERMM", "1/" + robyear);
        localStorage.setItem("name", res.data[0].FULLNAME + res.data[0].FRISTNAME_LOGIN);
        localStorage.setItem("lname", res.data[0].LASTNAME_LOGIN);
        localStorage.setItem("amount", res.data[0].SALARY_MONEY_2);
        localStorage.setItem("type_payment", "2");
        setIsShowPay2nd(true);
      });
  };
  const Pay1Kru = (status, robid, regisid, robyear, namee, tystd, majorid) => {
    axios
      .get(
        mua + "/admission/getEligibleInterviewReports_new/" +
          localStorage.getItem("citizent") +
          "/" +
          status +
          "/" +
          robid +
          "/" +
          regisid
      )
      .then((res) => {
        console.log(
          mua + "/admission/getEligibleInterviewReports_new/" +
            localStorage.getItem("citizent") +
            "/" +
            status +
            "/" +
            robid +
            "/" +
            regisid
        );
        console.log(res.data, "1234");
        localStorage.setItem("IDNOO", regisid);
        localStorage.setItem("stopdate", res.data[0].SALARY_DATE_CLOSE);
        localStorage.setItem("TERMM", "1/" + robyear);
        localStorage.setItem("name", res.data[0].FULLNAME + res.data[0].FRISTNAME_LOGIN);
        localStorage.setItem("lname", res.data[0].LASTNAME_LOGIN);
        localStorage.setItem("amount1", res.data[0].SALARY_MONEY_1);
        localStorage.setItem("amountfull", res.data[0].SALARY_MONEY_FULL);
        localStorage.setItem("type_payment", "1");
        localStorage.setItem("typestd", tystd);
        localStorage.setItem("namme", namee);
        localStorage.setItem("majj", majorid);
        localStorage.setItem("rob", robid);
        setModalPayKRU(true);
      });
  };
  const [IsShowPay2nd, setIsShowPay2nd] = useState(false);

  return (
    <div className="container-fluid  p-2">
      <MetaTags>
        <title>ข้อมูลการสมัคร มหาวิทยาลัยราชภัฏกำแพงเพชร</title>
        <meta
          name="description"
          content="ข้อมูลการสมัคร มหาวิทยาลัยราชภัฏกำแพงเพชร Kamphaeng Phet Rajabhat University"
        />
        <meta property="og:title" content="ข้อมูลการสมัคร มหาวิทยาลัยราชภัฏกำแพงเพชร" />
        <meta property="og:image" content="../../public/favicon.ico" />
      </MetaTags>
      {/* //////////////////////////////////////////////////////////// */}
      <Pane padding={9} backgroundColor="white" borderRadius={6} boxShadow="0px 0px 16px #00000030">
        <Pane
          display={"none"}
          flexDirection="column"
          backgroundColor="white"
          borderRadius={4}
          className="my-4 px-4 py-2"
        >
          <Text fontSize="18px" fontWeight="700" color="red">
            <blink>ประกาศ !!</blink>
          </Text>
          <Pane
            display={"none"}
            className="d-flex flex-column flex-wrap"
            gap={10}
            style={{
              overflowX: "auto",
            }}
          >
            {/* <div>
            {" "}
            <Button
              appearance="primary"
              intent=""
              size="large"
              fontSize={18}
              onClick={() => {
                window.open(
                  admission + "/public/news/1709281482.pdf"
                );
              }}
            >
              คลิกเพื่อดู ประกาศผลการคัดเลือกนักเรียนเพื่อเข้าศึกษาต่อภาคปกติ
              หลักสูตรครุศาสตรบัณฑิต (เพิ่มเติม) สำหรับทะเบียนสำรอง (ตัวสำรอง)
              รอบ 2 ประจำปีการศึกษา 2568
            </Button>
          </div> */}
            <div>
              <div
                // padding={21}
                //   appearance="primary"
                //   intent="success"
                //   fontSize={18}
                //   size="large"
                className="btn btn-success"
                onClick={() => {
                  window.open(
                    admission + "/public/news/1710744333.pdf"
                  );
                }}
              >
                คลิกเพื่อดู ประกาศมหาวิทยาลัยราชภัฏกำแพงเพชร เรื่อง
                รายชื่อผู้ผ่านการคัดเลือกนักเรียนเพื่อเข้าศึกษาต่อเพิ่มเติม <br />{" "}
                สำหรับผู้ที่ได้รับการคัดเลือกทะเบียนสำรอง หลักสูตรพยาบาลศาสตรบัณฑิต คณะพยาบาลศาสตร์
                รอบ 2 ประจำปีการศึกษา 2568
              </div>
            </div>
          </Pane>
        </Pane>
        <Text padding={10} fontSize={20} fontWeight={500}>
          ข้อมูลการสมัครเรียนมหาวิทยาลัยราชภัฏกำแพงเพชร
        </Text>
        {DataRegister.length !== 0 ? (
          <MDBDataTableV5
            theadColor="orange"
            theadTextWhite
            noRecordsFoundLabel="ไม่พบข้อมูล"
            searching={false}
            data={DataRegister}
            displayEntries={false}
            responsive
            striped
            bordered
            borderless
          />
        ) : (
          <Pane
            className="container"
            display="flex"
            justifyContent="center"
            alignItems="center"
            padding={150}
          >
            <Spinner size={50} />
          </Pane>
        )}
      </Pane>
      <Dialog
        shouldCloseOnEscapePress={false}
        shouldCloseOnOverlayClick={false}
        hasFooter={false}
        isShown={IshowEditFile}
        onCloseComplete={() => {
          setIshowEditFile(false);
        }}
        title="แก้ไขไฟล์ใบแสดงผลการเรียน"
      >
        <Pane>
          <FilePicker accept=".pdf" title="" onChange={onFileChange} />
        </Pane>
        <Pane className="mt-2" display="flex" justifyContent="end">
          <Button
            appearance="primary"
            intent="success"
            iconBefore={<FloppyDiskIcon />}
            onClick={UplodFile}
          >
            บันทึก
          </Button>
        </Pane>
      </Dialog>
      <>
        <Dialog
          isShown={isShowPay}
          onCloseComplete={() => {
            setisShowPay(false);
          }}
          hasFooter={false}
        >
          <Pane
            backgroundColor="#f2ebfb"
            color="#9667e0"
            padding={10}
            fontWeight={500}
            borderRadius={8}
            borderColor="#9667e0"
            border="solid"
            borderWidth="1px"
          >
            ท่านสามารถพิมพ์ใบแจ้งการชำระเงินค่าสมัครสอบคัดเลือกเพื่อชำระค่าสมัครผ่านช่องทางเคาน์เตอร์เซอร์วิส
            หรือช่องทางธนาคาร หรือชำระเงินค่าสมัครออนไลน์ได้
          </Pane>
          <Pane display="flex" flexDirection="column" gap="10px" className="mt-2">
            <Button
              appearance="minimal"
              backgroundColor="var(--btnpay)"
              className="btnsucc"
              color="white"
              onClick={() => {
                openAdmissionPrint(admission + "/dashboard_printbill?code_test=" +
                    Pay.ID_NO //6479902720คือรหัสประจำตัวผู้สมัคร
                );
              }}
            >
              พิมพ์ใบแจ้งชำระเงินค่าสมัคร {Pay.term}
            </Button>
            <Button
              appearance="primary"
              onClick={() => {
                window.open(
                  "https://e-payment.kpru.ac.th/pay/typepayment?comp=80427&orderRef1=" +
                    Pay.ID_NO +
                    "&amount=" +
                    Pay.amount +
                    "&endDate=" +
                    Pay.stopdate +
                    "&urlredirect=" + site + "/admission/Dataregister&term=" +
                    Pay.term +
                    "&name=" +
                    Pay.name +
                    "&lname=" +
                    Pay.lname
                );
              }}
            >
              ชำระเงินค่าสมัครออนไลน์{" "}
            </Button>
            <Pane display="flex" justifyContent="center">
              <img
                src="https://e-payment.kpru.ac.th/pay/public/images/Visa_Mastercard_jcb.jpg"
                alt="peyment credit"
              />
              <img
                src="https://e-payment.kpru.ac.th/pay/public/images/logo_ktb_next.png"
                alt="krungthai Next"
              />
              <img
                src="https://e-payment.kpru.ac.th/pay/public/images/promtpay1.png"
                style={{ width: "100px" }}
                alt="promtpay"
              />
            </Pane>
          </Pane>
        </Dialog>
        <Dialog
          isShown={IsShowPay2nd}
          title="พิมพ์ใบชำระเงินงวดที่ 2"
          onCloseComplete={() => {
            setIsShowPay2nd(false);
            localStorage.removeItem("IDNOO");
            localStorage.removeItem("stopdate");
            localStorage.removeItem("TERMM");
            localStorage.removeItem("name");
            localStorage.removeItem("lname");
            localStorage.removeItem("amount");
            localStorage.removeItem("type_payment");
          }}
          hasFooter={false}
        >
          <Pane
            backgroundColor="#f2ebfb"
            color="#9667e0"
            padding={10}
            fontWeight={500}
            borderRadius={8}
            borderColor="#9667e0"
            border="solid"
            borderWidth="1px"
          >
            ท่านสามารถพิมพ์ใบแจ้งการชำระเงินเพื่อชำระค่าธรรมเนียมการศึกษาผ่านช่องทางเคาน์เตอร์เซอร์วิส
            หรือช่องทางธนาคาร หรือชำระเงินค่าธรรมเนียมการศึกษาออนไลน์ได้
          </Pane>
          <Pane display="flex" flexDirection="column" gap="10px" className="mt-2">
            <Button
              backgroundColor="var(--btnpay)"
              className="btnsucc"
              color="white"
              appearance="minimal"
              onClick={() => {
                if (
                  localStorage.getItem("type_payment") === null ||
                  localStorage.getItem("type_payment") === "" ||
                  localStorage.getItem("type_payment") === undefined
                ) {
                  openAdmissionPrint(admission + "/dashboard_printbill?code_test=" +
                      localStorage.getItem("IDNOO")
                  );
                } else {
                  openAdmissionPrint(admission + "/student_printbill?code_test=" +
                      localStorage.getItem("IDNOO") +
                      "&typebill=" +
                      localStorage.getItem("type_payment") +
                      "&ad=1"
                  );
                }
              }}
            >
              พิมพ์ใบแจ้งชำระเงินค่าธรรมเนียมการศึกษางวดที่ 2
            </Button>
            <Button
              appearance="primary"
              onClick={() => {
                window.open(
                  "https://e-payment.kpru.ac.th/pay/typepayment?comp=80427&orderRef1=" +
                    localStorage.getItem("IDNOO") +
                    "&amount=" +
                    localStorage.getItem("amount") +
                    "&endDate=" +
                    localStorage.getItem("stopdate") +
                    "&urlredirect=" + site + "/admission/Dataregister&term=" +
                    localStorage.getItem("TERMM") +
                    "&name=" +
                    localStorage.getItem("name") +
                    "&lname=" +
                    localStorage.getItem("lname")
                );
              }}
            >
              ชำระเงินค่าธรรมเนียมการศึกษางวดที่2 ออนไลน์
            </Button>
            <Pane display="flex" justifyContent="center">
              <img
                src="https://e-payment.kpru.ac.th/pay/public/images/Visa_Mastercard_jcb.jpg"
                alt="peyment credit"
              />
              <img
                src="https://e-payment.kpru.ac.th/pay/public/images/logo_ktb_next.png"
                alt="krungthai Next"
              />
              <img
                src="https://e-payment.kpru.ac.th/pay/public/images/promtpay1.png"
                style={{ width: "100px" }}
                alt="promtpay"
              />
            </Pane>
          </Pane>
        </Dialog>
      </>
      <Dialog
        isShown={ModalPayKRU}
        onCloseComplete={() => {
          localStorage.removeItem("IDNOO");
          localStorage.removeItem("stopdate");
          localStorage.removeItem("TERMM");
          localStorage.removeItem("name");
          localStorage.removeItem("lname");
          localStorage.removeItem("amount1");
          localStorage.removeItem("amountfull");
          localStorage.removeItem("type_payment");
          localStorage.removeItem("namme");
          setModalPayKRU(false);
        }}
        hasFooter={false}
      >
        <Pane
          backgroundColor="#f2ebfb"
          color="#9667e0"
          padding={10}
          fontWeight={500}
          borderRadius={8}
          borderColor="#9667e0"
          border="solid"
          borderWidth="1px"
        >
          ท่านสามารถพิมพ์ใบแจ้งการชำระเงินเพื่อชำระค่าธรรมเนียมการศึกษาผ่านช่องทางเคาน์เตอร์เซอร์วิส
          หรือช่องทางธนาคาร หรือชำระเงินค่าธรรมเนียมการศึกษาออนไลน์ได้
        </Pane>
        <Pane display="flex" flexDirection="column" gap="10px" className="mt-2">
          {localStorage.getItem("namme") !== "ครุศาสตรบัณฑิต" &&
          localStorage.getItem("majj") !== "1110" &&
          localStorage.getItem("rob") !== "133" &&
          localStorage.getItem("rob") !== "131" ? (
            <>
              <Button
                appearance="minimal"
                // intent="success"
                backgroundColor="var(--btnpay)"
                className="btnsucc"
                color="white"
                // hidden={localStorage.getItem("majj")==="9903"}
                iconBefore={<FaReceipt />}
                onClick={() => {
                  if (
                    localStorage.getItem("type_payment") === null ||
                    localStorage.getItem("type_payment") === "" ||
                    localStorage.getItem("type_payment") === undefined
                  ) {
                    openAdmissionPrint(admission + "/dashboard_printbill?code_test=" +
                        localStorage.getItem("IDNOO")
                    );
                  } else {
                    openAdmissionPrint(admission + "/student_printbill?code_test=" +
                        localStorage.getItem("IDNOO") +
                        "&typebill=" +
                        localStorage.getItem("type_payment") +
                        "&ad=1"
                    );
                  }
                }}
              >
                พิมพ์ใบแจ้งชำระเงินค่าธรรมเนียมการศึกษา (แบ่งจ่ายงวดที่ 1)
              </Button>
              <Button
                iconBefore={<BsQrCode />}
                appearance="primary"
                onClick={() => {
                  window.open(
                    "https://e-payment.kpru.ac.th/pay/typepayment?comp=80427&orderRef1=" +
                      localStorage.getItem("IDNOO") +
                      "&amount=" +
                      localStorage.getItem("amount1") +
                      "&endDate=" +
                      localStorage.getItem("stopdate") +
                      "&urlredirect=" + site + "/admission/Dataregister&term=" +
                      localStorage.getItem("TERMM") +
                      "&name=" +
                      localStorage.getItem("name") +
                      "&lname=" +
                      localStorage.getItem("lname")
                  );
                }}
              >
                ชำระเงินค่าธรรมเนียมการศึกษาออนไลน์(แบ่งจ่ายงวดที่ 1)
              </Button>
            </>
          ) : (
            <></>
          )}
          <Button
            iconBefore={<FaReceipt />}
            appearance="minimal"
            // intent="success"
            backgroundColor="#5a189a"
            color="white"
            borderColor="#00000000"
            onClick={() => {
              let type = "4";
              if (localStorage.getItem("typestd") === "6") {
                type = "4";
              } else {
                type = "3";
              }
              if (
                localStorage.getItem("type_payment") === null ||
                localStorage.getItem("type_payment") === "" ||
                localStorage.getItem("type_payment") === undefined
              ) {
                openAdmissionPrint(admission + "/dashboard_printbill?code_test=" +
                    localStorage.getItem("IDNOO")
                );
              } else {
                // console.log(
                //   admission + "/student_printbill?code_test=" +
                //     localStorage.getItem("IDNOO") +
                //     "&typebill=" +
                //     type +
                //     "&ad=1"
                // );
                openAdmissionPrint(admission + "/student_printbill?code_test=" +
                    localStorage.getItem("IDNOO") +
                    "&typebill=" +
                    type +
                    "&ad=1"
                );
              }
            }}
            // hidden={localStorage.getItem("majj")==="9903"}
          >
            พิมพ์ใบแจ้งชำระเงินค่าธรรมเนียมการศึกษา (แบบเต็มจำนวน)
          </Button>
          <Button
            appearance="minimal"
            backgroundColor="#dc2f02"
            borderColor="#00000000"
            color="white"
            iconBefore={<BsQrCode />}
            onClick={() => {
              window.open(
                "https://e-payment.kpru.ac.th/pay/typepayment?comp=80427&orderRef1=" +
                  localStorage.getItem("IDNOO") +
                  "&amount=" +
                  localStorage.getItem("amountfull") +
                  "&endDate=" +
                  localStorage.getItem("stopdate") +
                  "&urlredirect=" + site + "/admission/Dataregister&term=" +
                  localStorage.getItem("TERMM") +
                  "&name=" +
                  localStorage.getItem("name") +
                  "&lname=" +
                  localStorage.getItem("lname")
              );
            }}
          >
            ชำระเงินค่าธรรมเนียมการศึกษาออนไลน์(เต็มจำนวน)
          </Button>
          <Pane display="flex" justifyContent="center">
            <img
              src="https://e-payment.kpru.ac.th/pay/public/images/Visa_Mastercard_jcb.jpg"
              alt="peyment credit"
            />
            <img
              src="https://e-payment.kpru.ac.th/pay/public/images/logo_ktb_next.png"
              alt="krungthai Next"
            />
            <img
              src="https://e-payment.kpru.ac.th/pay/public/images/promtpay1.png"
              style={{ width: "100px" }}
              alt="promtpay"
            />
          </Pane>
        </Pane>
      </Dialog>
    </div>
  );
}

export default NewDataRegister;


